import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { setFirmResult } from '../../features/searchResultSlice';
import { setSelectedFeature } from '../../features/selectionSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { TabView, TabPanel } from 'primereact/tabview';
import { useState, useEffect, useRef } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { RadioButton } from 'primereact/radiobutton';
import './OsbInfo.scss';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import WFS from 'ol/format/WFS';
import { Feature } from 'ol';
import { useTranslation } from 'react-i18next';
import { setHighlightGeomForTransportation } from '../../features/mapSlice';
import WKT from 'ol/format/WKT';
import { setShowLoading } from '../../features/sharedSlice';
import GeoJSON from 'ol/format/GeoJSON';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import { OsbInfoRestApi } from '../../utils/restapi/osb-info';


export default function OsbInfo(props: any) {

    const { fields, layer, feature } = props
    const toast = useRef<any>()
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const [ulasimInfo, setUlasimInfo] = useState<any>(null);
    const [aritmaInfo, setAritmaInfo] = useState<any>(null);
    const [yonetimInfo, setYonetimInfo] = useState<any>(null);
    const [planlarInfo, setPlanlarInfo] = useState<any>(null);
    const [parselInfo, setParselInfo] = useState<any>(null);
    const [service, setService] = useState<any>(null);
    const [zoneEdit, setZoneEdit] = useState<boolean>(false);
    const [aritmalar, setAritmalar] = useState<any>(undefined);

    const [elektrikTuketimInfo, setElektrikTuketimInfo] = useState<any>(null);
    const [elektrikTuketimYear, setElektrikTuketimYear] = useState<any>(null);
    const [elektrikChartData, setElektrikChartData] = useState<any>(null);

    const [suTuketimInfo, setSuTuketimInfo] = useState<any>(null);
    const [suTuketimYear, setSuTuketimYear] = useState<any>(null);
    const [suChartData, setSuChartData] = useState<any>(null);

    const [dogalgazTuketimInfo, setDogalgazTuketimInfo] = useState<any>(null);
    const [dogalgazTuketimYear, setDogalgazTuketimYear] = useState<any>(null);
    const [dogalgazChartData, setDogalgazChartData] = useState<any>(null);

    const [istihdamInfo, setIstihdamInfo] = useState<any>(null);
    const [istihdamYear, setIstihdamYear] = useState<any>(null);
    const [istihdamChartData, setIstihdamChartData] = useState<any>(null);
    const [selectedAritma, setSelectedAritma] = useState<any>(null);
    const iller = useAppSelector(state => state.sharedState.iller)
    const ilceler = useAppSelector(state => state.sharedState.ilceler)
    const zoneRoles = useAppSelector(state => state.sharedState.zoneRoles);
    const services = useAppSelector(state => state.layer.services)
    const token = useAppSelector(state => state.authState.token);
    const user = useAppSelector(state => state.sharedState.user);

    const [updateFields, setUpdateFields] = useState<any>(fields);

    const [altyapiInfo, setAltyapiInfo] = useState<any>();
    const [selectedYetkili, setSelectedYetkili] = useState<any>();
    const [selectedPlan, setSelectedPlan] = useState<any>();

    const [proceed, setProceed] = useState<any>(true);
    const [checkboxStatus, setCheckboxStatus] = useState<boolean>(false);
    const [infrastructureStatus, setInfrastructureStatus] = useState<boolean>(false);
    const [editToast, setEditToast] = useState<boolean>(false);
    const [editInfrastructureToast, setEditInfrastructureToast] = useState<boolean>(false);
    const [editPurificationToast, setEditPurificationToast] = useState<boolean>(false);

    const [updateMode, setUpdateMode] = useState<boolean>(false);
    const [updateInfrastructure, setUpdateInfrastructure] = useState<boolean>(false);
    const [epostaHatali, setEpostaHatali] = useState<boolean>(false);

    const [sicilNoHatali, setSicilNoHatali] = useState<boolean>(false);

    const [finishGeneral, setFinishGeneral] = useState<boolean>(true);
    const [heyetTipiDomain, setHeyetTipiDomain] = useState<any>();
    const [heyetGorevDomain, setHeyetGorevDomain] = useState<any>();
    const [tahsisdurumlar, setTahsisdurumlar] = useState<any>();

    const [editTuketimMode, setEditTuketimMode] = useState<boolean>(false)
    const [editTuketimToast, setEditTuketimToast] = useState<boolean>(false)
    const [tuketimToastCheckboxStatus, setTuketimToastCheckboxStatus] = useState<boolean>(false)
    const [tuketimEditTitle, setTuketimEditTitle] = useState<string>('')
    const [tuketimEditChartData, setTuketimEditChartData] = useState<any>(null)
    const [tuketimEditChartDataCopy, setTuketimEditChartDataCopy] = useState<any>(null)
    const [tuketimEditInput, setTuketimEditInput] = useState<any>(null)
    const [tuketimEditMonth, setTuketimEditMonth] = useState<any>(null)
    const [tuketimEditYear, setTuketimEditYear] = useState<any>(null)
    const [tuketimEditType, setTuketimEditType] = useState<string>('')

    const [years, setYears] = useState<any>([])
    const [atiksuBertarafYonetimi, setAtiksuBertarafYonetimi] = useState<any>();
    const [uygulananSurecBilgi, setUygulananSurecBilgi] = useState<any>();

    const [cevreIzinTarihi, setCevreIzinTarihi] = useState<any>();
    const [cevreIzinGecerlilikTarihi, setCevreIzinGecerlilikTarihi] = useState<any>();

    const [cevreIzniState, setCevreIzniState] = useState<any>(undefined);
    const [atikYonetimState, setAtikYonetimState] = useState<any>();
    const [kullanmaSuyuAritmaState, setKullanmaSuyuAritmaState] = useState<any>();
    const [sifirAtikState, setSifirAtikState] = useState<any>();
    const [cevreYonetimBirimiState, setCevreYonetimBirimiState] = useState<any>();
    const [merkeziAtiksuState, setMerkeziAtiksuState] = useState<any>(undefined);
    const [osbSinirState, setOsbSinirState] = useState<any>(undefined);

    const [atikYonetimDurum, setAtikYonetimDurum] = useState<any>(true);
    const [kullanmaSuyuAritmaDurum, setKullanmaSuyuAritmaDurum] = useState<any>(true);
    const [sifirAtikDurum, setSifirAtikDurum] = useState<any>(true);
    const [cevreYonetimDurum, setCevreYonetimDurum] = useState<any>(true);

    const [termStatus, setTermStatus] = useState<boolean>(false);


    const [activateAddScreen, setActivateAddScreen] = useState<boolean>(false);

    const [purificationStatus, setPurificationStatus] = useState<boolean>(false);

    const [addAritmaData, setAddAritmaData] = useState<any>();
    const [uygulananSurecValue, setUygulananSurecValue] = useState<any>();
    const [atiksuBertarafValue, setAtiksuBertarafValue] = useState<any>();

    const [purificationData, setPurificationData] = useState<any>({
        sinir_durumu: undefined,
        plan_durumu: undefined,
        aciklama: undefined,
        aritma_camur_miktari: undefined,
        desarj_havzasi: undefined,
        desarj_mesafesi: undefined,
        cevre_izni: undefined,
        cevre_izin_tarihi: null,
        cevre_izin_gecerlilik_tarihi: null,
        atik_yonetim_alt_faaliyet: undefined,
        kullanma_suyu_aritma_kapasite: undefined,
        sifir_atik_yonetim_sistemi: undefined,
        cevre_yonetim_birimi: undefined,
        "1_kademe_kapasite": undefined,
        "2_kademe_kapasite": undefined,
        "3_kademe_kapasite": undefined,
        uygulanan_surec: undefined,
        atiksu_bertaraf: undefined,
        merkezi_atiksu_tesisi: undefined
    });

    const applicationPeriod = [
        { name: "Fiziksel", id: 1 },
        { name: "Fiziksel-Biyolojik", id: 2 },
        { name: "Fiziksel-Kimyasal-Biyolojik", id: 3 },
        { name: "FizikSel-Kimyasal-İleri-Biyolojik", id: 4 },
        { name: "Kimyasal-İleri Biyolojik", id: 5 },
        { name: "Paket", id: 6 }
    ]
    const asidePeriod = [
        { name: "Alıcı Ortam", id: 1 },
        { name: "Belediye Sistemine", id: 2 },
        { name: "Diğer", id: 3 }
    ]

    const [chartData, setChartData] = useState({
        labels: ['A', 'B', 'C'],
        datasets: [
            {
                data: [300, 50, 100, 300, 50, 100, 300, 50, 100],
                backgroundColor: [
                    "#20DBD8",
                    "#7DE8E5",
                    "#A00C32",
                    "#BD6630",
                    "#CEB26A",
                    "#FF00C1",
                    "#FF5060",
                    "#FFC038",
                    "#FFFF7B",
                    "#BCFFDB",
                    "#002B36",
                    "#005A8D",
                    "#FF623A",
                    "#FFD35C",
                    "#FFFFC8"
                ],
                hoverBackgroundColor: [
                    "#20DBD8",
                    "#7DE8E5",
                    "#A00C32",
                    "#BD6630",
                    "#CEB26A",
                    "#FF00C1",
                    "#FF5060",
                    "#FFC038",
                    "#FFFF7B",
                    "#BCFFDB",
                    "#002B36",
                    "#005A8D",
                    "#FF623A",
                    "#FFD35C",
                    "#FFFFC8"
                ]
            }]
    });

    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: {
                    color: 'white'
                },
                position: 'right'
            }
        }
    });

    let basicOptions = {
        maintainAspectRatio: true,
        aspectRatio: 1.7,
        animation: false,
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#ebedef'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#ebedef'
                },
                grid: {
                    color: '#ebedef'
                }
            },
        }
    };


    useEffect(() => {
        const years = []
        const currentYear = new Date().getFullYear()
        for (let index = currentYear; index >= 2000; index--) {
            years.push(index)
        }
        setYears(years)
    }, [])


    useEffect(() => {

        if (sifirAtikState === true && purificationData?.sifir_atik_yonetim_sistemi === "") {
            setSifirAtikDurum(false)
        }
        if (atikYonetimState === true && purificationData?.atik_yonetim_alt_faaliyet === "") {
            setAtikYonetimDurum(false)
        }
        if (kullanmaSuyuAritmaState === true && purificationData?.kullanma_suyu_aritma_kapasite === "") {
            setKullanmaSuyuAritmaDurum(false)
        }
        if (cevreYonetimBirimiState === true && purificationData?.cevre_yonetim_birimi === "") {
            setCevreYonetimDurum(false)
        }

    }, [sifirAtikState, atikYonetimState, kullanmaSuyuAritmaState, cevreYonetimBirimiState])

    useEffect(() => {
        getTahsisDurumDomains();
        axios
            .get(
                process.env.REACT_APP_BASE_URL +
                `rest/v1/geoserver/osb/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=osb%3Aparsel_usr&maxFeatures=50&outputFormat=application%2Fjson`
            )
            .then((res) => {
                const geojson = new GeoJSON();
                const feature: any = geojson.readFeature(res.data.features[0]);
                const geom = feature.getGeometry()!.getCoordinates();
                const type = feature.getGeometry()!.getType().toUpperCase();
                const coordArr: any[] = [];
                const geomArr = geom[0][0].map((a: any) => a);

                for (const arr of geomArr) {
                    arr.splice(2);
                    coordArr.push(`${arr[0]} ${arr[1]}`);
                }

                if (feature) {
                    axios
                        .get(
                            process.env.REACT_APP_BASE_URL +
                            `rest/v1/geoserver/osb/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=parsel_usr&maxFeatures=50&outputFormat=application%2Fjson&CQL_FILTER=INTERSECTS(geom, ${type}(((${coordArr}))))`
                        )
                        .then((res) => { });
                }
            });
    }, [])

    const getTahsisDurumDomains = async () => {
        const response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8075/options?token=${getToken()}`)
        setTahsisdurumlar(response.data.options);
    }

    const getToken = () => {
        return localStorage.getItem('token');
    };

    const hideToast = () => {
        setEditToast(false)
        setUpdateMode(true)
        setCheckboxStatus(false)
    }
    const setTuketimEditToDefaults = () => {
        setTuketimEditChartData(null)
        setTuketimEditChartDataCopy(null)
        setTuketimEditInput(null)
        setTuketimEditMonth(null)
        setTuketimEditYear(null)
        setTuketimEditType('')
        setEditTuketimMode(false);
    }
    const hideTuketimToast = () => {
        setEditTuketimToast(false)
        setEditTuketimMode(true)
        setTuketimToastCheckboxStatus(false)
    }

    const hideToast2 = () => {
        setEditInfrastructureToast(false)
        setUpdateInfrastructure(true)
        setInfrastructureStatus(false)
    }
    const hideToast3 = () => {
        setEditPurificationToast(false)
        setPurificationStatus(true)
        setTermStatus(false)
    }
    const setHeyetTipiDomainHandler = async () => {
        try {
            const response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5415/options?token=${token}`)
            const options = response.data.options
            const heyetTipiDomainArray = options.map((obj: any) => { return { label: obj.desc, value: obj.id } })
            setHeyetTipiDomain(heyetTipiDomainArray)
            const responseGorev = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5647/options?token=${token}`)
            const optionsGorev = responseGorev.data.options
            const heyetGorevDomainArray = optionsGorev.map((obj: any) => { return { label: obj.desc, value: obj.id } })
            setHeyetGorevDomain(heyetGorevDomainArray)
        } catch (error) {
            console.error(error);
        }
    }

    const updateField = (value: string, name: string) => {
        let updatedValue: any = value

        if (name === 'eposta') {
            if (updatedValue.includes('@') && updatedValue.includes('.') && updatedValue.split('.')[1].length > 1) {
                setEpostaHatali(false)
            }
            else {
                if (updatedValue.length === 0) {
                    setEpostaHatali(false)
                }
                else {
                    setEpostaHatali(true)
                }
            }
        }
        if (name === 'osb_kurulus_tarihi') {
            const date = updatedValue.split('.')
            const formated = date[1] + '.' + date[0] + '.' + date[2]
            const d = new Date(formated);
            updatedValue = d.toISOString()
        }
        if (name === 'm_fiyati' || name === 'tahsis_birim_fiyat') {
            if (updatedValue.toString().split(',')[0].length > 10) {
                updatedValue = updatedValue.toString().slice(0, 10)
            }
        }

        if (name === 'kadin_istihdam' || name === 'istihdam_sayisi') {
            if (value.toString().length > 7) {
                updatedValue = Number(updatedValue.toString().slice(0, 7))
            }

        }

        if (name === "sicil_no") {
            if (name === "sicil_no" && /[^0-9]/.test(updatedValue.toString())) {
                setFinishGeneral(false);
                setSicilNoHatali(true)
            }
            else {
                setFinishGeneral(true);
                setSicilNoHatali(false)
            }
        }

        setUpdateFields({
            ...updateFields,
            [name]: updatedValue,
            'touch_date': new Date().toISOString(),
            'touch_by': user.id
        })
    }

    const updateYetkiliEmail = (value: string, name: string) => {
        if (name === 'eposta') {

            if ((value.includes('@') && value.includes('.') && value.split('.')[1].length > 1)) {
                setEpostaHatali(false)
            }
            else {
                if (value.length === 0) {
                    setEpostaHatali(false)
                }
                else {
                    setEpostaHatali(true)
                }
            }
            if (value.length !== 0 && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                setEpostaHatali(true)
            }
        }

        setSelectedYetkili({ ...selectedYetkili, eposta: value })
    }

    const updateOSBInfo = async () => {
        try {
            const updateFeature = new Feature();
            updateFeature.setProperties({ ...updateFields });
            updateFeature.setId(layer.name + '.' + fields.id);

            if (service) {
                const wfs = new WFS()
                const xml = (wfs.writeTransaction as any)([], [updateFeature], [], { hasZ: true, featureType: layer.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
                var xmlText = new XMLSerializer().serializeToString(xml)
                dispatch(setShowLoading(true));
                const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
                dispatch(setShowLoading(false));

                if (response.data.includes('TransactionSummary')) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'OSB Genel Bilgi Güncelleme Başarılı.' });
                    dispatch(setSelectedFeature(undefined));
                    refreshPanel();
                    setUpdateFields(false);
                } else {
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'OSB Genel Bilgi Güncelleme Başarısız.' });
                }
            } else {
                toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadı.' });
            }
        } catch (error) {
            dispatch(setShowLoading(false));
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'OSB Genel Bilgi Güncelleme Başarısız.' });
        }

    }
    const defaultChartBackgrounds = [
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',
        '#B68A33',

    ]
    const months = [
        { name: 'Ocak', value: 1 },
        { name: 'Şubat', value: 2 },
        { name: 'Mart', value: 3 },
        { name: 'Nisan', value: 4 },
        { name: 'Mayıs', value: 5 },
        { name: 'Haziran', value: 6 },
        { name: 'Temmuz', value: 7 },
        { name: 'Ağustos', value: 8 },
        { name: 'Eylül', value: 9 },
        { name: 'Ekim', value: 10 },
        { name: 'Kasım', value: 11 },
        { name: 'Aralık', value: 12 }
    ];


    const renewPurificationPage = async () => {
        try {
            const featuresResponse: any = await axios(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature&typeName=osb_sinir_usr&maxFeatures=1&outputFormat=application/json&featureID=${fields.id}` + (token ? `&token=${token}` : ''))
            const feature: any = featuresResponse.data.features[0]
            if (feature) {
                dispatch(setSelectedFeature(feature))
            }

        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: t('TOAST.Parcel Information Could Not Refresh') });
        }
    }

    const updateOSBPurification = async () => {

        const osbInfoObject = {
            "merkezi_atiksu_tesisi": purificationData.merkezi_atiksu_tesisi ? purificationData.merkezi_atiksu_tesisi : null,
            "1_kademe_kapasite": purificationData["1_kademe_kapasite"] ? purificationData["1_kademe_kapasite"].toString() : null,
            "2_kademe_kapasite": purificationData["2_kademe_kapasite"] ? purificationData["2_kademe_kapasite"].toString() : null,
            "3_kademe_kapasite": purificationData["3_kademe_kapasite"] ? purificationData["3_kademe_kapasite"].toString() : null,
            "uygulanan_surec": purificationData.uygulanan_surec ? purificationData.uygulanan_surec.id : 0,
            "atiksu_bertaraf": purificationData.atiksu_bertaraf ? purificationData.atiksu_bertaraf.id : 0,
            "aciklama": purificationData.aciklama ? purificationData.aciklama : "",
            "sinir_durumu": JSON.parse(purificationData.sinir_durumu ? purificationData.sinir_durumu : null),
            "plan_durumu": purificationData.plan_durumu ? purificationData.plan_durumu : "",
            "aritma_camur_miktari": purificationData.aritma_camur_miktari ? purificationData.aritma_camur_miktari : "",
            "desarj_havzasi": purificationData.desarj_havzasi ? purificationData.desarj_havzasi : "",
            "desarj_mesafesi": purificationData.desarj_mesafesi ? purificationData.desarj_mesafesi.toString() : null,
            "cevre_izni": JSON.parse(purificationData.cevre_izni ? purificationData.cevre_izni : "false"),
            "cevre_izin_tarihi": cevreIzinTarihi ? cevreIzinTarihi : null,
            "cevre_izin_gecerlilik_tarihi": cevreIzinGecerlilikTarihi ? cevreIzinGecerlilikTarihi : null,
            "atik_yonetim_alt_faaliyet": purificationData.atik_yonetim_alt_faaliyet ? purificationData.atik_yonetim_alt_faaliyet : "",
            "kullanma_suyu_aritma_kapasite": purificationData.kullanma_suyu_aritma_kapasite ? purificationData.kullanma_suyu_aritma_kapasite.toString() : null,
            "sifir_atik_yonetim_sistemi": purificationData.sifir_atik_yonetim_sistemi ? purificationData.sifir_atik_yonetim_sistemi : "",
            "cevre_yonetim_birimi": purificationData.cevre_yonetim_birimi ? purificationData.cevre_yonetim_birimi : "",
            active: true
        }

        try {
            dispatch(setShowLoading(true));
            await OsbInfoRestApi.editPurification(selectedAritma?.id, osbInfoObject).then((res: any) => {
                if (res && res.status === 200) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'OSB Genel Bilgi Güncelleme Başarılı!' });
                    setPurificationStatus(false)
                    setSelectedAritma(null)
                    renewPurificationPage()
                }
                dispatch(setShowLoading(false));
            })
        } catch (error) {
            dispatch(setShowLoading(false));
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'OSB Genel Bilgi Güncelleme Başarısız.' });
        }
    }


    useEffect(() => {
        setUpdateFields(fields);
        const service = services.find((obj: any) => obj.id === layer.service_id);
        setService(service);
        getParselInfo(fields.id)
        getSektorInfo(fields.id)
        getUlasimInfo(fields.id)
        getAritmaInfo(fields.id)
        getYonetimInfo(fields.id)
        getPlanlarInfo(fields.id)
        getTuketimInfo(fields.id)
        setAltyapiInfo(
            {
                elektrik: fields.elektrik,
                su: fields.su,
                dogalgaz: fields.dogalgaz,
                atiksu: fields.atiksu,
                telekom: fields.telekom,
                itfaiye: fields.itfaiye,
                yol: fields.yol,
                elektrik_dagitim: fields.elektrik_dagitim,
                su_dagitim: fields.su_dagitim,
                dogalgaz_dagitim: fields.dogalgaz_dagitim
            }
        )
        setHeyetTipiDomainHandler();
        const editZone = zoneRoles.find(obj => obj.zone_id === Number(fields.zone_id));
        if (editZone && editZone.permission > 1) {
            setZoneEdit(true);
        }
    }, [fields])


    const getDatasetsDataForChart = (info: any, key: string, year: any) => {
        const datasetsDataForChart = []
        for (let index = 1; index < 13; index++) {
            const element = info[year] ? info[year].filter((month: any) => {
                return month.ay === index
            }) : null

            if (element) {
                datasetsDataForChart.push(element[0]?.[key] ? element[0]?.[key] : 0)
            }
            else {
                datasetsDataForChart.push(0)
            }
        }
        return datasetsDataForChart
    }

    useEffect(() => {
        if (elektrikTuketimYear && elektrikTuketimInfo) {
            const data = {
                labels: months.map(e => e.name),
                datasets: [
                    {
                        backgroundColor: defaultChartBackgrounds,
                        borderWidth: 1,
                        data: getDatasetsDataForChart(elektrikTuketimInfo, 'elektrik', elektrikTuketimYear)
                    }
                ]
            }
            setElektrikChartData(data)
        }

    }, [elektrikTuketimYear, elektrikTuketimInfo])
    useEffect(() => {
        if (suTuketimYear && suTuketimInfo) {
            const data = {
                labels: months.map(e => e.name),
                datasets: [
                    {

                        backgroundColor: defaultChartBackgrounds,
                        borderWidth: 1,
                        data: getDatasetsDataForChart(suTuketimInfo, 'su', suTuketimYear)
                    }
                ]
            }
            setSuChartData(data)
        }

    }, [suTuketimYear, suTuketimInfo])
    useEffect(() => {
        if (dogalgazTuketimYear && dogalgazTuketimInfo) {
            const data = {
                labels: months.map(e => e.name),
                datasets: [
                    {
                        backgroundColor: defaultChartBackgrounds,
                        borderWidth: 1,
                        data: getDatasetsDataForChart(dogalgazTuketimInfo, 'dogalgaz', dogalgazTuketimYear)
                    }
                ]
            }
            setDogalgazChartData(data)
        }

    }, [dogalgazTuketimYear, dogalgazTuketimInfo])
    useEffect(() => {
        if (istihdamYear && istihdamInfo) {
            const data = {
                labels: months.map(e => e.name),
                datasets: [
                    {
                        backgroundColor: defaultChartBackgrounds,
                        borderWidth: 1,
                        data: getDatasetsDataForChart(istihdamInfo, 'istihdam_sayisi', istihdamYear)
                    }
                ]
            }
            setIstihdamChartData(data)
        }

    }, [istihdamYear, istihdamInfo])

    useEffect(() => {
        if (activeIndex === 4) {
            const features = []
            const wkt = new WKT()

            const portFeature = wkt.readFeature(ulasimInfo.portWkt)
            const airportFeature = wkt.readFeature(ulasimInfo.airportWkt)
            const railwayFeature = wkt.readFeature(ulasimInfo.railwayWkt)
            const roadFeature = wkt.readFeature(ulasimInfo.roadWkt)
            features.push(portFeature)
            features.push(airportFeature)
            features.push(railwayFeature)
            features.push(roadFeature)

            dispatch(setHighlightGeomForTransportation(features))
        } else {
            dispatch(setHighlightGeomForTransportation(null))
        }

    }, [activeIndex, ulasimInfo])


    const groupBy = (items: any, key: any) => items.reduce(
        (result: any, item: any) => ({
            ...result,
            [item[key]]: [
                ...(result[item[key]] || []),
                item,
            ],
        }),
        {},
    );

    const getUlasimInfo = async (osb_id: number) => {
        try {
            const ulasimResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/ulasim/${osb_id}`)
            setUlasimInfo(ulasimResponse.data.data)
        } catch (error) {
            console.log(error);
        }
    }

    const getParselInfo = async (osb_id: number) => {
        try {
            const parselResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/parsel/${osb_id}`)
            setParselInfo(parselResponse.data.data)
        } catch (error) {
            console.log(error);
        }
    }
    const getSektorInfo = async (osb_id: number) => {
        try {
            const sektorResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/sektor/${osb_id}`)
            const sektorData = sektorResponse.data.data
            const sektorChartData = {
                labels: sektorData.filter((obj: any) => obj.sektor_tanim !== null).map((obj: any) => obj.sektor_tanim),
                datasets: [
                    {
                        data: sektorData.filter((obj: any) => obj.sektor_tanim !== null).map((obj: any) => obj.count),
                        backgroundColor: [
                            "#20DBD8",
                            "#7DE8E5",
                            "#A00C32",
                            "#BD6630",
                            "#CEB26A",
                            "#FF00C1",
                            "#FF5060",
                            "#FFC038",
                            "#FFFF7B",
                            "#BCFFDB",
                            "#002B36",
                            "#005A8D",
                            "#FF623A",
                            "#FFD35C",
                            "#FFFFC8"
                        ],
                        hoverBackgroundColor: [
                            "#20DBD8",
                            "#7DE8E5",
                            "#A00C32",
                            "#BD6630",
                            "#CEB26A",
                            "#FF00C1",
                            "#FF5060",
                            "#FFC038",
                            "#FFFF7B",
                            "#BCFFDB",
                            "#002B36",
                            "#005A8D",
                            "#FF623A",
                            "#FFD35C",
                            "#FFFFC8"
                        ]
                    }]
            }
            setChartData(sektorChartData)
        } catch (error) {
            console.log(error);
        }
    }

    const getAritmaInfo = async (osb_id: number) => {
        try {
            const aritmaResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/aritma/${osb_id}`)
            const filteredActiveAritma: any = aritmaResponse?.data?.data?.filter((data: any) => data.active === true)
            setAritmaInfo(filteredActiveAritma)
        } catch (error) {
            console.log(error);
        }
    }

    const getTuketimInfo = async (osb_id: number, refreshMode?: boolean) => {
        try {
            const tuketimResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/newTuketim/${osb_id}/1`)
            const tuketim = tuketimResponse.data.data;

            const elektrikTuketim = groupBy(tuketim.filter((obj: any) => obj.elektrik), 'yil')
            const suTuketim = groupBy(tuketim.filter((obj: any) => obj.su), 'yil')
            const dogalgazTuketim = groupBy(tuketim.filter((obj: any) => obj.dogalgaz), 'yil')
            const istihdam = groupBy(tuketim.filter((obj: any) => obj.istihdam_sayisi), 'yil')

            setElektrikTuketimInfo(elektrikTuketim);
            setSuTuketimInfo(suTuketim);
            setDogalgazTuketimInfo(dogalgazTuketim);
            setIstihdamInfo(istihdam)

            if (!refreshMode) {
                setElektrikTuketimYear(new Date().getMonth() !== 0 ? new Date().getFullYear() : (new Date().getFullYear()) - 1)
                setSuTuketimYear(new Date().getMonth() !== 0 ? new Date().getFullYear() : (new Date().getFullYear()) - 1)
                setDogalgazTuketimYear(new Date().getMonth() !== 0 ? new Date().getFullYear() : (new Date().getFullYear()) - 1)
                setIstihdamYear(new Date().getMonth() !== 0 ? new Date().getFullYear() : (new Date().getFullYear()) - 1)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getYonetimInfo = async (osb_id: number) => {
        try {
            const yonetimResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/yonetim/${osb_id}`)
            const filteredActiveYonetim: any = yonetimResponse?.data?.data?.filter((data: any) => data.active === true)
            setYonetimInfo(filteredActiveYonetim)

        } catch (error) {
            console.log(error);
        }
    }
    const getPlanlarInfo = async (osb_id: number) => {
        try {
            const planResponse: any = await axios(process.env.REACT_APP_BASE_URL +
                `rest/v1/plan-gml/osb/100000/0/filename/1/equals/osb/${osb_id}`, { params: { token: token }, })
            // const filteredActiveYonetim: any = yonetimResponse?.data?.data?.filter((data: any) => data.active === true)
            setPlanlarInfo(planResponse.data.plan)

        } catch (error) {
            console.log(error);
        }
    }

    const bodyTemplate = (rowData: any) => {
        return <Button onClick={() => { setSelectedAritma(rowData) }} icon="pi pi-chevron-right" className="p-button-rounded p-button-outlined" aria-label="Submit" />
    }

    const yonetimBodyTemplate = (rowData: any) => {
        return <Button onClick={() => { setSelectedYetkili(rowData) }} icon="pi pi-chevron-right" className="p-button-rounded p-button-outlined" aria-label="Submit" />
    }
    const planBodyTemplate = (rowData: any) => {
        return <Button onClick={() => { setSelectedPlan(rowData) }} icon="pi pi-chevron-right" className="p-button-rounded p-button-outlined" aria-label="Submit" />
    }

    const goreviBodyTemplate = (rowData: any) => {
        return heyetTipiDomain.find((domain: any) => domain.value === rowData.gorevi)?.label
    }

    const sinirDurumBodyTemplaye = (rowData: any) => {
        return rowData?.sinir_durumu === true ? "Sınır İçinde" : rowData?.sinir_durumu === false ? "Sınır Dışında" : "-"
    }

    const refreshPanel = async () => {
        try {
            if (service.url && updateFields.id) {
                const featuresResponse: any = await axios(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature&token=${token}&typeName=osb_sinir_usr&maxFeatures=1&outputFormat=application/json&featureID=${updateFields.id}`)
                const feature: any = featuresResponse.data.features[0]
                if (feature) {
                    dispatch(setSelectedFeature(feature))
                }
                // dispatch(setSelectedFeatureForInfo(undefined));
            }
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: t('TOAST.Parcel Information Could Not Refresh') });
        }
    }
    const onClickDeleteYetkili = () => {
        confirmDialog({
            message: 'Yetkiliyi Silmek İstediğinize Emin Misiniz?',
            header: t('TOAST.Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    const body = { active: false, sb_id: feature.properties.id }
                    await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-osb/put/yonetim/${selectedYetkili.id}?token=${token}`, body)
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: t('TOAST.Authorization deleted successfully') });
                    setSelectedYetkili(undefined);
                    refreshPanel();
                } catch (error) {
                    console.error(error);
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Authorization could not delete.' });
                    setSelectedYetkili(undefined);
                }
            },
            reject: () => { },
            acceptLabel: `${t('TEXT.Yes')}`,
            rejectLabel: `${t('TEXT.No')}`
        });
    }
    const onClickEditYetkili = () => {


        confirmDialog({
            message: t('TOAST.Are You Sure You Want To Edit The Authority?'),
            header: t('TOAST.Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    const newObj = {
                        "eposta": selectedYetkili?.eposta,
                        "gid": selectedYetkili?.gid,
                        "gorevi": selectedYetkili?.gorevi,
                        "heyet_tipi": selectedYetkili?.heyet_tipi,
                        "kurumu": selectedYetkili?.kurumu,
                        "osb_gid": selectedYetkili?.osb_gid,
                        "sanayi_sicil_no": selectedYetkili?.sanayi_sicil_no,
                        "sb_id": selectedYetkili?.sb_id,
                        "yetkili_adi": selectedYetkili?.yetkili_adi,
                        "yetkili_tc_no": selectedYetkili?.yetkili_tc_no,
                        "active": true
                    }
                    // setSelectedYetkili({ ...selectedYetkili, active: true })
                    const id = selectedYetkili.id;
                    delete selectedYetkili.id
                    await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-osb/put/yonetim/${id}?token=${token}`, newObj)
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: t('TOAST.Authorization Edited Successfully') });
                    setSelectedYetkili(undefined);
                    refreshPanel();
                } catch (error) {
                    console.error(error);
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: t('TOAST.Authorization could not edit') });
                    setSelectedYetkili(undefined);
                }

            },
            reject: () => { },
            acceptLabel: `${t('TEXT.Yes')}`,
            rejectLabel: `${t('TEXT.No')}`
        });
    }
    const onClickInsertYetkili = () => {
        confirmDialog({
            message: 'Yetkiliyi Eklemek İstediğinize Emin Misiniz?',
            header: t('TOAST.Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    selectedYetkili.sb_id = fields.id;
                    delete selectedYetkili.new;
                    await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-osb/yonetim?token=${token}`, selectedYetkili)
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: t('TOAST.Authorization Added Successfully') });
                    setSelectedYetkili(undefined);
                    refreshPanel();
                } catch (error) {
                    console.error(error);
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: t('TOAST.Authorization could not add') });
                    setSelectedYetkili(undefined);
                }
            },
            reject: () => { },
            acceptLabel: `${t('TEXT.Yes')}`,
            rejectLabel: `${t('TEXT.No')}`
        });
    }

    const unvanBodyTemplate = (rowData: any) => {
        const data = heyetGorevDomain.find((obj: any) => obj.value === rowData.gorevi)?.label
        return <div>{data}</div>
    }

    const onClickEditAltyapi = async () => {
        try {
            const feature: any = new Feature();
            feature.setProperties({ ...altyapiInfo });
            feature.setId(layer.name + '.' + fields.id);
            if (service) {
                const wfs = new WFS()
                const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: layer.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
                var xmlText = new XMLSerializer().serializeToString(xml)
                const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
                if (response.data.includes('TransactionSummary')) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Altyapı Güncelleme Başarılı.' });
                    refreshPanel();
                    setUpdateInfrastructure(false)
                } else {
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Altyapı Güncelleme Başarısız.' });
                }
            } else {
                toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadı.' });
                console.error('Service Bulunamadi');
            }
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Altyapı Güncelleme Başarısız.' });
        }
    }


    const formatDate = (value: any) => {
        const date = new Date(value)
        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }) as any;
    }
    const handleChange = (e: any, name?: any) => {
        // e.preventDefault();

        if (e.target !== undefined) {

            if (e.target?.id === "atiksu_bertaraf") {
                setAtiksuBertarafYonetimi(e.target.value)
                setPurificationData({
                    ...purificationData,
                    [e.target?.id]: e.target.value,
                });
            }
            else if (e.target?.id === "uygulanan_surec") {
                setUygulananSurecBilgi(e.target.value)
                setPurificationData({
                    ...purificationData,
                    [e.target?.id]: e.target.value,
                });
            }
            else {
                setPurificationData({
                    ...purificationData,
                    [e.target?.id]: e.target.value,
                });

                if (sifirAtikState === true) {
                    if (e.target?.id === "sifir_atik_yonetim_sistemi") {
                        if (e.target.value === "") {
                            setSifirAtikDurum(false)
                            setPurificationData({
                                ...purificationData,
                                sifir_atik_yonetim_sistemi: ""
                            })
                        }
                        else {
                            setSifirAtikDurum(true)
                        }
                    }
                }

                if (atikYonetimState === true) {

                    if (e.target?.id === "atik_yonetim_alt_faaliyet") {
                        if (e.target.value === "") {
                            setAtikYonetimDurum(false)
                            setPurificationData({
                                ...purificationData,
                                atik_yonetim_alt_faaliyet: ""
                            })
                        }
                        else {
                            setAtikYonetimDurum(true)
                        }
                    }
                }

                if (kullanmaSuyuAritmaState === true) {

                    if (e.target.id === "kullanma_suyu_aritma_kapasite") {
                        if (e.target?.value === "") {
                            setKullanmaSuyuAritmaDurum(false)
                            setPurificationData({
                                ...purificationData,
                                kullanma_suyu_aritma_kapasite: ""
                            })
                        }
                        else {
                            setKullanmaSuyuAritmaDurum(true)
                        }
                    }
                }

                if (cevreYonetimBirimiState === true) {

                    if (e.target.id === "cevre_yonetim_birimi") {
                        if (e.target?.value === "") {
                            setCevreYonetimDurum(false)
                            setPurificationData({
                                ...purificationData,
                                cevre_yonetim_birimi: ""
                            })
                        }
                        else {
                            setCevreYonetimDurum(true)
                        }
                    }
                }
            }
        }
    }

    useEffect(() => {
        if (selectedAritma) {
            const arr = []
            for (const [key, value] of Object.entries(selectedAritma) as any) {
                if (key !== 'id' && key !== 'gid' && key !== 'sb_id' && key !== 'parsel_id' && key !== 'osb_gid')
                    arr.push({ key, value })
            }
            setAritmalar(arr)
        }

    }, [selectedAritma])

    const onElektrikTuketimYearSelected = (year: any) => {
        setElektrikTuketimYear(year)

    }
    const onSuYearSelected = (year: any) => {
        setSuTuketimYear(year)

    }
    const onDogalgazYearSelected = (year: any) => {
        setDogalgazTuketimYear(year)

    }
    const onIstihdamYearSelected = (year: any) => {
        setIstihdamYear(year)

    }
    const onTuketimEditCompleteRefresh = () => {

        setTuketimEditToDefaults()

        getTuketimInfo(fields.id, true)
        setEditTuketimMode(false);
    }

    const onElektrikEditClicked = () => {
        setTuketimEditType('elektrik')
        setEditTuketimToast(true)
        setTuketimEditTitle('Elektrik Tüketim Miktarı')
        setTuketimEditYear(elektrikTuketimYear)
    }
    const onSuEditClicked = () => {
        setTuketimEditType('su')

        setEditTuketimToast(true)
        setTuketimEditTitle('Su Tüketim Miktarı')
        setTuketimEditYear(suTuketimYear)
    }
    const onDogalgazEditClicked = () => {
        setTuketimEditType('dogalgaz')
        setEditTuketimToast(true)
        setTuketimEditTitle('Dogalgaz Tüketim Miktarı')
        setTuketimEditYear(dogalgazTuketimYear)

    }
    const onIstihdamEditClicked = () => {
        setTuketimEditType('istihdam_sayisi')
        setEditTuketimToast(true)
        setTuketimEditTitle('Istihdam Sayısı')
        setTuketimEditYear(istihdamYear)

    }

    const onTuketimEditMonthSelected = (month: any) => {
        setTuketimEditMonth(null)
        setTuketimEditMonth(month)

        setTuketimEditInput(tuketimEditChartData.datasets[0].data[month - 1])

        const editedTuketimChart = structuredClone(tuketimEditChartData)
        for (let index = 0; index < 13; index++) {
            if (editedTuketimChart.datasets[0].data[index] !== tuketimEditChartDataCopy.datasets[0].data[index]) {
                editedTuketimChart.datasets[0].backgroundColor[index] = '#FF0000'
            }
        }
        for (let index = 0; index < 13; index++) {
            if (editedTuketimChart.datasets[0].backgroundColor[index] !== '#FF0000') {
                editedTuketimChart.datasets[0].backgroundColor[index] = defaultChartBackgrounds[index]
            }
        }
        editedTuketimChart.datasets[0].backgroundColor[month - 1] = '#14D300'
        setTuketimEditChartData(editedTuketimChart)
    }

    const onTuketimEditChanged = (e: any) => {
        let value = e.value
        setTuketimEditInput(value)

    }

    const onDegisiklikEkleButtonClicked = () => {
        let newChart = structuredClone(tuketimEditChartData)
        structuredClone(tuketimEditChartDataCopy)

        newChart.datasets[0].data[tuketimEditMonth - 1] = tuketimEditInput ? tuketimEditInput : 0.00
        for (let index = 0; index < 13; index++) {
            if (newChart.datasets[0].data[index] !== tuketimEditChartDataCopy.datasets[0].data[index]) {
                newChart.datasets[0].backgroundColor[index] = '#FF0000'
            }

        }

        setTuketimEditChartData(newChart)
        setTuketimEditMonth(null)
        setTuketimEditInput(null)
    }

    const onTuketimEditCompleteClick = async () => {
        const values = []
        for (let index = 0; index < tuketimEditChartData.datasets[0].data.length; index++) {
            if (tuketimEditChartData.datasets[0].backgroundColor[index] === '#FF0000') {
                values.push({ ay: index + 1, value: tuketimEditChartData.datasets[0].data[index] })
            }
        }

        const body = {
            sb_id: fields.id,
            sb_turu: 1,
            values: values,
            type: tuketimEditType,
            yil: tuketimEditYear
        }
        axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/tuketim?token=${token}`, body).then((response) => {
            onTuketimEditCompleteRefresh()

        }).catch((error) => {

        })



    }

    useEffect(() => {
        let info
        if (tuketimEditType !== '') {

            if (tuketimEditType === 'elektrik') {
                info = structuredClone(elektrikTuketimInfo)
            }
            else if (tuketimEditType === 'su') {
                info = structuredClone(suTuketimInfo)

            }
            else if (tuketimEditType === 'dogalgaz') {
                info = structuredClone(dogalgazTuketimInfo)
            }
            else if (tuketimEditType === 'istihdam_sayisi') {
                info = structuredClone(istihdamInfo)
            }
            if (tuketimEditYear) {
                const data = {
                    labels: months.map(e => e.name),
                    datasets: [
                        {

                            backgroundColor: defaultChartBackgrounds,
                            borderWidth: 1,
                            data: getDatasetsDataForChart(info, tuketimEditType, tuketimEditYear)
                        }
                    ]
                }
                setTuketimEditChartData(structuredClone(data))
                setTuketimEditChartDataCopy(structuredClone(data))
            }
        }
    }, [tuketimEditYear])

    useEffect(() => {

        const findAsidePeriod = asidePeriod.find((item) => item.id === selectedAritma?.atiksu_bertaraf)
        const findApplicationPeriod = applicationPeriod.find((item) => item.id === selectedAritma?.uygulanan_surec)
        const findDate = selectedAritma?.cevre_izin_tarihi
        const findDate2 = selectedAritma?.cevre_izin_gecerlilik_tarihi

        if (atiksuBertarafYonetimi === undefined) {
            setAtiksuBertarafYonetimi(findAsidePeriod)
        }
        if (uygulananSurecBilgi === undefined) {
            setUygulananSurecBilgi(findApplicationPeriod)
        }
        if (cevreIzinTarihi === "Invalid Date" || cevreIzinTarihi === undefined) {
            setCevreIzinTarihi(findDate)
        }
        if (cevreIzinGecerlilikTarihi === "Invalid Date" || cevreIzinGecerlilikTarihi === undefined) {
            setCevreIzinGecerlilikTarihi(findDate2)
        }

    }, [applicationPeriod, asidePeriod, selectedAritma])


    useEffect(() => {
        if (selectedAritma && Object.keys(selectedAritma).length > 0) {

            setPurificationData(
                {
                    sinir_durumu: selectedAritma.sinir_durumu,
                    plan_durumu: selectedAritma.plan_durumu,
                    aciklama: selectedAritma.aciklama,
                    aritma_camur_miktari: selectedAritma.aritma_camur_miktari,
                    desarj_havzasi: selectedAritma.desarj_havzasi,
                    desarj_mesafesi: selectedAritma.desarj_mesafesi,
                    cevre_izni: selectedAritma.cevre_izni,
                    cevre_izin_tarihi: selectedAritma.cevre_izin_tarihi,
                    cevre_izin_gecerlilik_tarihi: selectedAritma.cevre_izin_gecerlilik_tarihi,
                    atik_yonetim_alt_faaliyet: selectedAritma.atik_yonetim_alt_faaliyet,
                    kullanma_suyu_aritma_kapasite: selectedAritma.kullanma_suyu_aritma_kapasite,
                    sifir_atik_yonetim_sistemi: selectedAritma.sifir_atik_yonetim_sistemi,
                    cevre_yonetim_birimi: selectedAritma.cevre_yonetim_birimi,
                    ada_no: selectedAritma.ada_no,
                    atiksu_bertaraf: selectedAritma.atiksu_bertaraf,
                    merkezi_atiksu_tesisi: selectedAritma.merkezi_atiksu_tesisi,
                    uygulanan_surec: selectedAritma.uygulanan_surec,
                    "1_kademe_kapasite": selectedAritma["1_kademe_kapasite"],
                    "2_kademe_kapasite": selectedAritma["2_kademe_kapasite"],
                    "3_kademe_kapasite": selectedAritma["3_kademe_kapasite"],
                }
            )
        }
    }, [selectedAritma])

    const cancelProcess = () => {
        setPurificationStatus(false)
        setSelectedAritma(null)
        renewPurificationPage()
    }

    useEffect(() => {
        if (kullanmaSuyuAritmaState === true) {
            if (purificationData?.kullanma_suyu_aritma_kapasite !== "") {
                setKullanmaSuyuAritmaDurum(true)
            }
            else if (purificationData?.kullanma_suyu_aritma_kapasite === "") {
                setKullanmaSuyuAritmaDurum(false)
            }
        }
    }, [purificationData])


    useEffect(() => {
        if (sifirAtikState === false) {
            setPurificationData({
                ...purificationData,
                sifir_atik_yonetim_sistemi: ""
            })
            setSifirAtikDurum(true)
        }
        if (cevreYonetimBirimiState === false) {
            setPurificationData({
                ...purificationData,
                cevre_yonetim_birimi: ""
            })
            setCevreYonetimDurum(true)
        }
        if (kullanmaSuyuAritmaState === false) {
            setPurificationData({
                ...purificationData,
                kullanma_suyu_aritma_kapasite: ""
            })
            setKullanmaSuyuAritmaDurum(true)
        }
        if (atikYonetimState === false) {
            setPurificationData({
                ...purificationData,
                atik_yonetim_alt_faaliyet: ""
            });
            setAtikYonetimDurum(true)
        }
    }, [sifirAtikState, cevreYonetimBirimiState, kullanmaSuyuAritmaState, atikYonetimState])

    useEffect(() => {
        if (cevreIzniState === true) {
            setPurificationData({
                ...purificationData,
                cevre_izni: true,
            });
        }
        else if (cevreIzniState === false) {
            setPurificationData({
                ...purificationData,
                cevre_izni: false,
                cevre_izin_tarihi: null,
                cevre_izin_gecerlilik_tarihi: null,
            });
        }
        else if (merkeziAtiksuState === true) {
            setPurificationData({
                ...purificationData,
                merkezi_atiksu_tesisi: true,
            });
        }
        else if (merkeziAtiksuState === false) {
            setPurificationData({
                ...purificationData,
                merkezi_atiksu_tesisi: false,
            });
        }
        else if (atikYonetimState === true) {
            setPurificationData({
                ...purificationData,
            });
        }
        else if (atikYonetimState === false) {
            setPurificationData({
                ...purificationData,
                atik_yonetim_alt_faaliyet: ""
            });
        }
        else if (kullanmaSuyuAritmaState === true) {
            setPurificationData({
                ...purificationData,
            });
        }
        else if (kullanmaSuyuAritmaState === false) {
            setPurificationData({
                ...purificationData,
                kullanma_suyu_aritma_kapasite: ""
            });
        }
        else if (sifirAtikState === true) {
            setPurificationData({
                ...purificationData,
            });
        }
        else if (sifirAtikState === false) {
            setPurificationData({
                ...purificationData,
                sifir_atik_yonetim_sistemi: ""
            });
        }
        else if (cevreYonetimBirimiState === true) {
            setPurificationData({
                ...purificationData,
            });
        }
        else if (cevreYonetimBirimiState === false) {
            setPurificationData({
                ...purificationData,
                cevre_yonetim_birimi: ""
            });
        }
        else if (osbSinirState === true) {
            setPurificationData({
                ...purificationData,
                sinir_durumu: true,
            });
        }
        else if (osbSinirState === false) {
            setPurificationData({
                ...purificationData,
                sinir_durumu: false,
            });
        }
        else {
            setPurificationData({
                ...purificationData,
                merkezi_atiksu_tesisi: selectedAritma ? selectedAritma.merkezi_atiksu_tesisi : false,
                sinir_durumu: selectedAritma ? selectedAritma.sinir_durumu : false,
                cevre_izni: selectedAritma ? selectedAritma.cevre_izni : false,
                cevre_izin_tarihi: selectedAritma?.cevre_izin_tarihi,
                cevre_izin_gecerlilik_tarihi: selectedAritma?.cevre_izin_gecerlilik_tarihi,
            });
        }
    }, [cevreIzniState, merkeziAtiksuState, osbSinirState, atikYonetimState, kullanmaSuyuAritmaState, sifirAtikState, cevreYonetimBirimiState])


    const deletePurification = (id: any) => {
        confirmDialog({
            message: 'Arıtma Bilgisini Silmek İstediğinize Emin Misiniz ?',
            header: t('TOAST.Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    dispatch(setShowLoading(true))
                    await OsbInfoRestApi.deletePurification(id).then((res: any) => {
                        if (res && res.status === 200) {
                            toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Arıtma Bilgi Silme İşlemi Başarılı!' });
                            setPurificationStatus(false)
                            setSelectedAritma(null)
                            renewPurificationPage();
                        }
                        dispatch(setShowLoading(false));
                    })
                } catch (error) {
                    dispatch(setShowLoading(false))
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: "Arıtma Bilgisi Silme İşlemi Başarısız." });
                }
            },
            reject: () => { },
            acceptLabel: `${t('TEXT.Yes')}`,
            rejectLabel: `${t('TEXT.No')}`
        });
    }


    const addPurification = () => {
        confirmDialog({
            message: 'Arıtma Bilgisini Eklemek İstediğinize Emin Misiniz ?',
            header: t('TOAST.Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                const purificationObject = {
                    "parsel_no": "",
                    "ada_no": "",
                    "osb_id": fields.id ? fields.id.toString() : "",
                    "sb_id": fields.id ? fields.id.toString() : "",
                    "merkezi_atiksu_tesisi": addAritmaData?.merkezi_atiksu_tesisi ? addAritmaData?.merkezi_atiksu_tesisi : false,
                    "1_kademe_kapasite": addAritmaData?.["1_kademe_kapasite"] ? addAritmaData["1_kademe_kapasite"].toString() : null,
                    "2_kademe_kapasite": addAritmaData?.["2_kademe_kapasite"] ? addAritmaData["2_kademe_kapasite"].toString() : null,
                    "3_kademe_kapasite": addAritmaData?.["3_kademe_kapasite"] ? addAritmaData["3_kademe_kapasite"].toString() : null,
                    "uygulanan_surec": addAritmaData?.uygulanan_surec ? addAritmaData?.uygulanan_surec : null,
                    "atiksu_bertaraf": addAritmaData?.atiksu_bertaraf ? addAritmaData?.atiksu_bertaraf : null,
                    "aciklama": addAritmaData?.aciklama ? addAritmaData?.aciklama : "",
                    "sinir_durumu": addAritmaData?.sinir_durumu ? addAritmaData?.sinir_durumu : null,
                    "plan_durumu": addAritmaData?.plan_durumu ? addAritmaData?.plan_durumu : "",
                    "aritma_camur_miktari": addAritmaData?.aritma_camur_miktari ? addAritmaData?.aritma_camur_miktari.toString() : "",
                    "desarj_havzasi": addAritmaData?.desarj_havzasi ? addAritmaData?.desarj_havzasi.toString() : "",
                    "desarj_mesafesi": addAritmaData?.desarj_mesafesi ? addAritmaData?.desarj_mesafesi : null,
                    "cevre_izni": addAritmaData?.cevre_izni ? addAritmaData?.cevre_izni : null,
                    "cevre_izin_tarihi": addAritmaData?.cevre_izin_tarihi ? addAritmaData?.cevre_izin_tarihi : null,
                    "cevre_izin_gecerlilik_tarihi": addAritmaData?.cevre_izin_gecerlilik_tarihi ? addAritmaData?.cevre_izin_gecerlilik_tarihi : null,
                    "atik_yonetim_alt_faaliyet": addAritmaData?.atik_yonetim_alt_faaliyet ? addAritmaData?.atik_yonetim_alt_faaliyet : "",
                    "kullanma_suyu_aritma_kapasite": addAritmaData?.kullanma_suyu_aritma_kapasite ? addAritmaData?.kullanma_suyu_aritma_kapasite.toString() : "",
                    "sifir_atik_yonetim_sistemi": addAritmaData?.sifir_atik_yonetim_sistemi ? addAritmaData?.sifir_atik_yonetim_sistemi : "",
                    "cevre_yonetim_birimi": addAritmaData?.cevre_yonetim_birimi ? addAritmaData?.cevre_yonetim_birimi : "",
                }

                try {
                    dispatch(setShowLoading(true))
                    await OsbInfoRestApi.addPurification(purificationObject).then((res: any) => {
                        if (res && res.status === 200) {
                            toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Arıtma Bilgi Ekleme İşlemi Başarılı!' });
                            setAddAritmaData(null)
                            setActivateAddScreen(false)
                            renewPurificationPage();
                        }
                        dispatch(setShowLoading(false));
                    })
                } catch (error) {
                    dispatch(setShowLoading(false))
                    toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: "Arıtma Bilgisi Ekleme İşlemi Başarısız." });
                }
            },
            reject: () => { },
            acceptLabel: `${t('TEXT.Yes')}`,
            rejectLabel: `${t('TEXT.No')}`
        });
    }


    return (
        <>
            {/* {!showEtahsis && */}
            <Dialog header={'OSB Bilgileri'} className="feature-dialog" visible={true} modal={false} onHide={() => { dispatch(setSelectedFeature(undefined)); dispatch(setFirmResult(null)); }}>
                <TabView activeIndex={activeIndex} onTabChange={(e) => { setActiveIndex(e.index); setTuketimEditToDefaults() }}>
                    <TabPanel header="Genel">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label >OSB Adı</label>
                                    <InputText maxLength={255} disabled={!updateMode} onChange={(e) => updateField(e.target.value, 'adi')} value={updateFields.adi ? updateFields.adi : ''} />
                                </div>
                                <div className="field">
                                    <label >İl</label>
                                    <InputText maxLength={255} disabled value={iller.find(obj => obj.id === updateFields.il_kodu)?.adi} />
                                </div>
                                <div className="field">
                                    <label >İlçe</label>
                                    <InputText maxLength={255} disabled value={ilceler.find(obj => obj.ilce_kodu === updateFields.ilce_kodu)?.adi} />
                                </div>
                                <div className="field">
                                    <label >Sicil No</label>
                                    <InputText maxLength={5} disabled={!updateMode} onChange={(e: any) =>
                                        updateField(e.target?.value, 'sicil_no')} value={updateFields.sicil_no ? updateFields.sicil_no : ''}
                                    />
                                    {sicilNoHatali &&
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <i className='pi pi-info-circle' style={{ marginRight: '0.5em', fontSize: '1rem', color: '#D94B4B' }}></i>
                                            <p style={{ color: '#D94B4B', fontSize: '12px' }}>Sicil No rakam harici bir değer içeremez!</p>
                                        </div>
                                    }
                                </div>
                                <div className="field">
                                    <label >Tahsis Ortalama Birim Fiyatı(TL)</label>
                                    <InputNumber disabled={!updateMode} min={0} minFractionDigits={2} maxFractionDigits={2} onChange={(e: any) => updateField(e.value, 'tahsis_birim_fiyat')} value={updateFields.tahsis_birim_fiyat ? updateFields.tahsis_birim_fiyat : ''} />
                                </div>
                                <div className="field">
                                    <label >Alanı(ha)</label>
                                    <InputNumber disabled minFractionDigits={2} maxFractionDigits={2} value={updateFields.alan?.toFixed(2)} />
                                </div>
                                <div className="field">
                                    <label >OSB m² Fiyati</label>
                                    <InputNumber disabled={!updateMode} mode="decimal" min={0} minFractionDigits={2} maxFractionDigits={2} onChange={(e: any) => updateField(e.value, 'm_fiyati')} value={updateFields.m_fiyati} />
                                </div>
                                <div className="field">
                                    <label >Tanıtım Videosu</label>
                                    <video></video>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                    {!updateMode && layer.perm >= 3 && zoneEdit &&
                                        <Button onClick={() => {
                                            setEditToast(true)
                                        }}>Güncelle</Button>
                                    }
                                    {updateMode &&
                                        <>
                                            <Button onClick={() => { renewPurificationPage(); setUpdateMode(false) }}>İptal</Button>
                                            <Button disabled={epostaHatali || !finishGeneral} onClick={() => { updateOSBInfo() }}>Kaydet</Button>
                                        </>
                                    }
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label>OSB Türü</label>
                                    <Dropdown disabled={!updateMode} value={updateFields.osb_turu} options={layer.fields.find((obj: any) => obj.name === 'osb_turu').domain} optionLabel='desc' optionValue='id'
                                        onChange={(e) => updateField(e.value, 'osb_turu')}></Dropdown>
                                </div>
                                <div className="field">
                                    <label>Kuruluş Tarihi</label>
                                    {!updateMode ?
                                        <InputText maxLength={255} disabled value={updateFields.osb_kurulus_tarihi ? formatDate(updateFields.osb_kurulus_tarihi) : "-"} /> :
                                        <Calendar dateFormat="dd.mm.yy"
                                            value={new Date(updateFields.osb_kurulus_tarihi)}
                                            onChange={(e: any) => updateField(formatDate(e.value), 'osb_kurulus_tarihi')} />
                                    }
                                </div>
                                <div className="field">
                                    <label>Sanayi Parsel Sayısı</label>
                                    <InputText maxLength={255} disabled value={parselInfo?.sanayi_parseli1} />
                                </div>
                                <div className="field">
                                    <label>Boş Sanayi Parsel Sayısı</label>
                                    <InputText maxLength={255} disabled value={parselInfo?.sanayi_parseli1 - parselInfo?.dolu_sanayi_parseli1} />
                                </div>
                                <div className="field">
                                    <label>Tahsis Bedel Durumu <i style={{ cursor: 'help' }} title="Tahsis Bedel Durumundan Yararlanma Durumu" className="pi pi-info-circle" ></i></label>
                                    <Dropdown disabled={!updateMode} options={tahsisdurumlar} optionLabel='desc' optionValue='id' value={updateFields.tahsis_bedel_durumu ? updateFields.tahsis_bedel_durumu : ''} onChange={(e) => updateField(e.target.value, 'tahsis_bedel_durumu')} />
                                </div>
                                <div className="field">
                                    <label>İstihdam Sayısı</label>
                                    <InputNumber mode="decimal" disabled={true}
                                        value={(istihdamInfo && istihdamInfo[Object.keys(istihdamInfo)[Object.keys(istihdamInfo).length - 1]] ? istihdamInfo[Object.keys(istihdamInfo)[Object.keys(istihdamInfo).length - 1]].reduce((max: any, obj: any) => {
                                            return obj.ay > max.ay ? obj : max;
                                        }, istihdamInfo[Object.keys(istihdamInfo)[Object.keys(istihdamInfo).length - 1]][0]).istihdam_sayisi : null)}
                                    />

                                </div>
                                <div className="field">
                                    <label>Kadın İstihdam Sayısı</label>
                                    <InputNumber
                                        // min={0} 
                                        mode="decimal"
                                        disabled={!updateMode}
                                        // value={updateFields.kadin_istihdam} 
                                        // onChange={(e: any) => updateField(e.value, 'kadin_istihdam')} 

                                        value={+updateFields.kadin_istihdam !== 0 && !isNaN(+updateFields.kadin_istihdam) ? +updateFields.kadin_istihdam : 0}
                                        onKeyDown={(e: any) => {
                                            const selection = e.target.value.substring(
                                                e.target.selectionStart,
                                                e.target.selectionEnd,
                                            );
                                            const deger = (updateFields as any).kadin_istihdam;
                                            if (selection === "" && deger && deger.toString().length === 7) {
                                                if (!isNaN(+e.key)) {
                                                    e.preventDefault()
                                                }
                                            }
                                        }}
                                        onChange={(e: any) => updateField(e.value, 'kadin_istihdam')}
                                    />
                                </div>
                                <div style={{ height: '65px' }}>
                                    <label>Sanayi Parseli Üretim Doluluk Oranı <i style={{ cursor: 'help' }} title="Üretim Aşamasındaki Parsellerin Tüm Parsellere Oranı" className="pi pi-info-circle" ></i></label>
                                    <ProgressBar value={((parselInfo?.uretim_dolu_parseli1 / parselInfo?.sanayi_parseli1) * 100).toFixed(2)}></ProgressBar>
                                </div>
                                <div style={{ height: '65px' }}>
                                    <label>Sanayi Parseli Doluluk Oranı <i style={{ cursor: 'help' }} title="Tahsis Edilmiş Parsellerin Tüm Parsellere Oranı" className="pi pi-info-circle" ></i></label>
                                    <ProgressBar value={((parselInfo?.dolu_sanayi_parseli1 / parselInfo?.sanayi_parseli1) * 100).toFixed(2)}></ProgressBar>
                                </div>
                                <div>
                                    <label>Firma Sektör Bilgileri</label>
                                    <Chart type="doughnut" data={chartData} options={lightOptions} />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="İletişim">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label >Telefon Numarası</label>
                                    <InputMask
                                        id="telefon"
                                        disabled={!updateMode}
                                        mask="0 (999) 999-9999"
                                        value={updateFields.telefon_no ? updateFields.telefon_no : ''}
                                        onChange={(e) => updateField(e.target.value, 'telefon_no')} />
                                    {/* onBlur={firmaForm.handleBlur} */}
                                    {/* /> */}
                                    {/* <InputText maxLength={255} disabled={!updateMode} value={updateFields.telefon_no ? updateFields.telefon_no : ''} onChange={(e) => updateField(e.target.value, 'telefon_no')} /> */}
                                </div>
                                <div className="field">
                                    <label >E-Posta Adresi</label>
                                    <InputText maxLength={255} disabled={!updateMode} value={updateFields.eposta ? updateFields.eposta : ''} onChange={(e) => updateField(e.target.value, 'eposta')} />
                                    {epostaHatali && <div style={{ fontSize: '12px' }}>Lütfen geçerli bir eposta formatı giriniz.</div>}
                                </div>
                                <div className="field">
                                    <label >Kep Adresi</label>
                                    <InputText maxLength={255} disabled={!updateMode} value={updateFields.kep_adresi ? updateFields.kep_adresi : ''} onChange={(e) => updateField(e.target.value, 'kep_adresi')} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                    {!updateMode && layer.perm >= 3 && zoneEdit &&
                                        <Button onClick={() => {
                                            setEditToast(true)
                                        }}>Güncelle</Button>
                                    }
                                    {updateMode &&
                                        <>
                                            <Button onClick={() => { refreshPanel(); setUpdateMode(false) }}>İptal</Button>
                                            <Button disabled={epostaHatali} onClick={() => { updateOSBInfo() }}>Kaydet</Button>
                                        </>
                                    }
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label >Adres</label>
                                    <InputText maxLength={255} disabled={!updateMode} value={updateFields.adres ? updateFields.adres : ''} onChange={(e) => updateField(e.target.value, 'adres')} />
                                </div>
                                <div className="field">
                                    <label >Web Adresi</label>
                                    <InputText maxLength={255} disabled={!updateMode} value={updateFields.web_adresi ? updateFields.web_adresi : ''} onChange={(e) => updateField(e.target.value, 'web_adresi')} />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Altyapı">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Elektrik</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, elektrik: e.value })} checked={altyapiInfo?.elektrik} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, elektrik: e.value, elektrik_dagitim: null })} checked={!altyapiInfo?.elektrik} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                    <div>
                                        {altyapiInfo?.elektrik &&
                                            <Dropdown
                                                disabled={!(layer.perm === 7) || !updateInfrastructure} onChange={(e) => { setAltyapiInfo({ ...altyapiInfo, elektrik_dagitim: e.value }) }} value={altyapiInfo?.elektrik_dagitim}
                                                options={layer.fields.find((obj: any) => obj.name === 'elektrik_dagitim')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}>
                                            </Dropdown>
                                        }
                                    </div>
                                </div>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Su</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, su: e.value })} checked={altyapiInfo?.su} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, su: e.value, su_dagitim: null })} checked={!altyapiInfo?.su} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                    <div>
                                        {altyapiInfo?.su &&
                                            <Dropdown disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, su_dagitim: e.value })} value={altyapiInfo?.su_dagitim}
                                                options={layer.fields.find((obj: any) => obj.name === 'su_dagitim')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}>
                                            </Dropdown>
                                        }
                                    </div>
                                </div>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Doğalgaz</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, dogalgaz: e.value })} checked={altyapiInfo?.dogalgaz} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, dogalgaz: e.value, dogalgaz_dagitim: null })} checked={!altyapiInfo?.dogalgaz} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                    <div>
                                        {altyapiInfo?.dogalgaz &&
                                            <Dropdown disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, dogalgaz_dagitim: e.value })} value={altyapiInfo?.dogalgaz_dagitim}
                                                options={layer.fields.find((obj: any) => obj.name === 'dogalgaz_dagitim')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}>
                                            </Dropdown>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Atıksu Arıtma</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, atiksu: e.value })} checked={altyapiInfo?.atiksu} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, atiksu: e.value })} checked={!altyapiInfo?.atiksu} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Telekom</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, telekom: e.value })} checked={altyapiInfo?.telekom} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, telekom: e.value })} checked={!altyapiInfo?.telekom} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>İtfaiye</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, itfaiye: e.value })} checked={altyapiInfo?.itfaiye} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, itfaiye: e.value })} checked={!altyapiInfo?.itfaiye} />
                                            <label>Yok</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='altapi-field-container'>
                                    <div className='field-header'>Yol</div>
                                    <div className='field-boolean-container'>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={true} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, yol: e.value })} checked={altyapiInfo?.yol} />
                                            <label>Var</label>
                                        </div>
                                        <div>
                                            <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !updateInfrastructure} value={false} onChange={(e) => setAltyapiInfo({ ...altyapiInfo, yol: e.value })} checked={!altyapiInfo?.yol} />
                                            <label>Yok</label>
                                            <label>{altyapiInfo?.yol}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: "48%", justifyContent: "space-between" }}>
                            {!updateInfrastructure &&
                                layer.perm >= 3 && zoneEdit &&
                                <Button style={{ minWidth: '80px' }} label='Güncelle' onClick={() => {
                                    setEditInfrastructureToast(true)
                                }}></Button>
                            }
                            {updateInfrastructure &&
                                <>
                                    <Button onClick={() => { refreshPanel(); setUpdateInfrastructure(false) }}>İptal</Button>
                                    <Button onClick={() => { onClickEditAltyapi(); }}>Kaydet</Button>
                                </>
                            }
                        </div>
                    </TabPanel>
                    <TabPanel header="Tüketim & Istihdam">
                        {elektrikTuketimInfo && <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ marginBottom: '20px', fontSize: '16px' }}>Elektrik Tüketim Miktarı</div>
                                <Dropdown value={elektrikTuketimYear} options={years} onChange={(e) => onElektrikTuketimYearSelected(e.value)} />
                            </div>
                            <Chart type="bar" data={elektrikChartData} options={basicOptions} />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', columnGap: '20px', marginBottom: '20px' }}>
                                {!editTuketimMode && layer.perm >= 3 && zoneEdit &&
                                    <Button onClick={onElektrikEditClicked}>Güncelle</Button>
                                }

                            </div>
                        </div>}

                        <div style={{ width: '100%', border: '1px solid #fff', marginBottom: '20px' }}></div>
                        {suTuketimInfo && <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ marginBottom: '20px', fontSize: '16px' }}>Su Tüketim Miktarı (m³)</div>
                                <Dropdown value={suTuketimYear} options={years} onChange={(e) => onSuYearSelected(e.value)} />
                            </div>
                            <Chart type="bar" data={suChartData} options={basicOptions} />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', columnGap: '20px', marginBottom: '20px' }}>
                                {!editTuketimMode && layer.perm >= 3 && zoneEdit &&
                                    <Button onClick={onSuEditClicked}>Güncelle</Button>
                                }

                            </div>
                        </div>}

                        <div style={{ width: '100%', border: '1px solid #fff', marginBottom: '20px' }}></div>

                        {dogalgazTuketimInfo && <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ marginBottom: '20px', fontSize: '16px' }}>Doğalgaz Tüketim Miktarı (m³) </div>
                                <Dropdown value={dogalgazTuketimYear} options={years} onChange={(e) => onDogalgazYearSelected(e.value)} />
                            </div>
                            <Chart type="bar" data={dogalgazChartData} options={basicOptions} />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', columnGap: '20px', marginBottom: '20px' }}>
                                {!editTuketimMode && layer.perm >= 3 && zoneEdit &&
                                    <Button onClick={onDogalgazEditClicked}>Güncelle</Button>
                                }

                            </div>
                        </div>}
                        {istihdamInfo && <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ marginBottom: '20px', fontSize: '16px' }}>Istihdam Sayısı </div>
                                <Dropdown value={istihdamYear} options={years} onChange={(e) => onIstihdamYearSelected(e.value)} />
                            </div>
                            <Chart type="bar" data={istihdamChartData} options={basicOptions} />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', columnGap: '20px', marginBottom: '20px' }}>
                                {!editTuketimMode && layer.perm >= 3 && zoneEdit &&
                                    <Button onClick={onIstihdamEditClicked}>Güncelle</Button>
                                }

                            </div>
                        </div>}

                        {editTuketimMode &&
                            <Dialog header={tuketimEditTitle} className="feature-dialog" style={{ minWidth: '600px' }} visible={true} modal={false} onHide={setTuketimEditToDefaults}>
                                {<div style={{ marginTop: '10px', justifyContent: 'flex-end', columnGap: '10px', display: 'flex', flexDirection: 'row' }}>
                                    <label style={{ marginRight: 'auto', fontSize: '2em' }} >{tuketimEditYear}</label>
                                    <Dropdown value={tuketimEditMonth} onChange={(e) => onTuketimEditMonthSelected(e.value)} options={months} optionLabel="name"
                                        placeholder="Ay" className="w-full md:w-14rem" />
                                    <InputNumber disabled={!tuketimEditMonth} mode="decimal" min={0} minFractionDigits={tuketimEditType === 'istihdam_sayisi' ? 0 : 2} maxFractionDigits={tuketimEditType === 'istihdam_sayisi' ? 0 : 2} value={tuketimEditInput} onChange={(e) => onTuketimEditChanged(e)}
                                        onKeyDown={tuketimEditType === 'istihdam_sayisi' ? (e: any) => {
                                            const selection = e.target.value.substring(
                                                e.target.selectionStart,
                                                e.target.selectionEnd,
                                            );
                                            const deger = tuketimEditInput;
                                            if (selection === "" && deger && parseFloat(deger.toString()).toFixed(2).split('.')[0].length === 7 && e.target.selectionEnd < 14) {
                                                if (!isNaN(+e.key)) {
                                                    e.preventDefault()
                                                }
                                            }
                                        } : (e: any) => {
                                            const selection = e.target.value.substring(
                                                e.target.selectionStart,
                                                e.target.selectionEnd,
                                            );
                                            const deger = tuketimEditInput;
                                            if ((selection === "" && deger && parseFloat(deger.toString()).toFixed(2).split('.')[0].length === 10 && e.target.selectionEnd < 14) || (e.target.selectionStart <= 13 &&
                                                e.target.selectionEnd >= 16)) {
                                                if (!isNaN(+e.key)) {
                                                    e.preventDefault()
                                                }
                                            }
                                        }}
                                    ></InputNumber>
                                </div>}
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <small hidden={!((tuketimEditType && tuketimEditType !== 'istihdam_sayisi' && tuketimEditInput && parseFloat(tuketimEditInput).toFixed(2).split('.')[0].length > 10) || (tuketimEditType && tuketimEditType == 'istihdam_sayisi' && tuketimEditInput && parseFloat(tuketimEditInput).toFixed(2).split('.')[0].length > 7) || (tuketimEditInput && tuketimEditInput.toString().includes('+')))} className="p-error">Maksimum karakterden fazla girildi</small>
                                </div>
                                {
                                    <div style={{ marginTop: '10px', justifyContent: 'flex-end', columnGap: '10px', display: 'flex', flexDirection: 'row' }}>
                                        <Button label='Değişikliği Ekle' onClick={() => { onDegisiklikEkleButtonClicked() }} disabled={((tuketimEditType && tuketimEditType !== 'istihdam_sayisi' && tuketimEditInput && parseFloat(tuketimEditInput).toFixed(2).split('.')[0].length > 10) || (tuketimEditType && tuketimEditType == 'istihdam_sayisi' && tuketimEditInput && parseFloat(tuketimEditInput).toFixed(2).split('.')[0].length > 7) || (tuketimEditInput && tuketimEditInput.toString().includes('+')))}></Button>
                                    </div>
                                }
                                <Chart type="bar" data={tuketimEditChartData} options={basicOptions} />
                                {
                                    <>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', columnGap: '20px', marginTop: '20px' }}>
                                            <Button onClick={setTuketimEditToDefaults}>İptal</Button>
                                            <Button onClick={onTuketimEditCompleteClick}>Kaydet</Button>
                                        </div>

                                    </>
                                }
                            </Dialog>
                        }
                    </TabPanel>
                    <TabPanel header="Ulaşım">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label >En Yakın Karayolu</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.roadName} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Karayoluna Uzaklık</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.roadDist !== undefined ? (ulasimInfo?.roadDist / 1000).toFixed() + ' km' : ''} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Liman</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.portName} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Limana Uzaklık</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.portDist !== undefined ? (ulasimInfo?.portDist / 1000).toFixed() + ' km' : ''} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                <div className="field">
                                    <label >En Yakın Demiryolu</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.railwayName} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Demiryoluna Uzaklık</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.railwayDist !== undefined ? (ulasimInfo?.railwayDist / 1000).toFixed() + ' km' : ''} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Havalimanı</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.airportName} />
                                </div>
                                <div className="field">
                                    <label >En Yakın Havalimanına Uzaklık</label>
                                    <InputText maxLength={255} disabled value={ulasimInfo?.airportDist !== undefined ? (ulasimInfo?.airportDist / 1000).toFixed() + ' km' : ''} />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Arıtma">
                        {layer.perm >= 3 && zoneEdit && <Button style={{ minWidth: '80px' }} label='Arıtma Tesisi Ekle'
                            onClick={() => setActivateAddScreen(true)}
                        ></Button>}
                        <DataTable value={aritmaInfo} responsiveLayout="scroll" >
                            <Column field="ada_no" header="Ada"></Column>
                            <Column field="parsel_no" header="Parsel"></Column>
                            <Column field="mahalle" header="Mahalle"></Column>
                            <Column field="plan_durumu" header="Plan Durumu"></Column>
                            <Column field="sinir_durumu" body={sinirDurumBodyTemplaye} header="OSB Sınır Durumu" ></Column>
                            <Column header="Detay" body={bodyTemplate}></Column>
                        </DataTable>

                    </TabPanel>
                    {!window.location.href.includes('sb-atlas') && +(localStorage.getItem('selectedUserGroupId')!) !== 1443 && <TabPanel header="Yönetim">
                        {layer.perm >= 3 && zoneEdit && <Button label='Yetkili Ekle' onClick={() => { setSelectedYetkili({ new: true }) }}></Button>}
                        <DataTable value={yonetimInfo} responsiveLayout="scroll">
                            <Column field="yetkili_adi" header="Yetkili Kişi Adı"></Column>
                            <Column header="Ünvan" body={unvanBodyTemplate}></Column>
                            <Column header="Görevi" field="gorevi" body={goreviBodyTemplate}></Column>
                            <Column header="Detay" body={yonetimBodyTemplate}></Column>
                        </DataTable>
                    </TabPanel>}
                    {!window.location.href.includes('sb-atlas') && +(localStorage.getItem('selectedUserGroupId')!) !== 1443 && <TabPanel header="Planlar">
                        <DataTable value={planlarInfo} responsiveLayout="scroll">
                            <Column field="pin" header="Plan Pin Numarası" style={{ width: '18%' }}></Column>
                            <Column field="planadi" header="Plan Adı"></Column>
                            <Column field="buyukluk" header="Plan Büyüklüğü" style={{ width: '15%' }}></Column>
                            <Column field="onay_tarihi" header="Onay Tarihi" style={{ width: '15%' }}></Column>
                            <Column field="aciklama" header="Açıklama"></Column>
                            <Column header="" body={planBodyTemplate}></Column>
                        </DataTable>
                    </TabPanel>}
                </TabView>
            </Dialog >
            {
                activateAddScreen &&
                <Dialog header={'Arıtma Tesisi Bilgileri'} className="feature-dialog"
                    visible={true} modal={false} onHide={() => {
                        setActivateAddScreen(false); setAddAritmaData(null);
                        setAtiksuBertarafValue(null);
                        setUygulananSurecValue(null);
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="field">
                            <label >OSB Sınırları İçinde</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) => setAddAritmaData({ ...addAritmaData, sinir_durumu: e.target.value })}
                                        checked={addAritmaData?.sinir_durumu === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) => setAddAritmaData({ ...addAritmaData, sinir_durumu: e.target.value })}
                                        checked={addAritmaData?.sinir_durumu === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        <div className="field">
                            <label >Plan Durumu</label>
                            <InputText maxLength={50}
                                id='plan_durumu'
                                onChange={(e) => setAddAritmaData({ ...addAritmaData, plan_durumu: e.target.value })}
                            />
                        </div>
                        <div className="field">
                            <label>Merkezi Atıksu arıtma tesisi var mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, merkezi_atiksu_tesisi: e.target.value })
                                        }
                                        checked={addAritmaData?.merkezi_atiksu_tesisi === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) =>
                                            setAddAritmaData({
                                                ...addAritmaData, merkezi_atiksu_tesisi: e.target.value,
                                                "1_kademe_kapasite": null,
                                                "2_kademe_kapasite": null,
                                                "3_kademe_kapasite": null
                                            })
                                        }
                                        checked={addAritmaData?.merkezi_atiksu_tesisi === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.merkezi_atiksu_tesisi === true) &&
                            (
                                <div className='center-purification' style={{ display: "flex" }}>
                                    <div className="field">
                                        <label>1. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            id='1_kademe_kapasite'
                                            name="1_kademe_kapasite"
                                            onChange={(e) =>
                                                setAddAritmaData({ ...addAritmaData, "1_kademe_kapasite": e.value })
                                            }
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = addAritmaData["1_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <label>2. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            id='2_kademe_kapasite'
                                            name="2_kademe_kapasite"
                                            onChange={(e) =>
                                                setAddAritmaData({ ...addAritmaData, "2_kademe_kapasite": e.value })
                                            }
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = addAritmaData["2_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <label>3. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            id='3_kademe_kapasite'
                                            name="3_kademe_kapasite"
                                            onChange={(e) =>
                                                setAddAritmaData({ ...addAritmaData, "3_kademe_kapasite": e.value })
                                            }
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = addAritmaData["3_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="field">
                            <label >Uygulanan Sürece İlişkin Bilgiler</label>
                            <Dropdown
                                id="uygulanan_surec"
                                filter
                                filterBy="name"
                                value={uygulananSurecValue}
                                options={applicationPeriod}
                                optionLabel='name'
                                onChange={(e: any) => {
                                    setAddAritmaData({ ...addAritmaData, uygulanan_surec: e.target.value.id })
                                    setUygulananSurecValue(e.value)
                                }}
                            />
                        </div>
                        <div className="field">
                            <label >Atıksu Bertaraf Yöntemi</label>
                            <Dropdown
                                id="atiksu_bertaraf"
                                filter
                                filterBy="name"
                                value={atiksuBertarafValue}
                                options={asidePeriod}
                                optionLabel='name'
                                onChange={(e: any) => {
                                    setAddAritmaData({ ...addAritmaData, atiksu_bertaraf: e.target.value.id })
                                    setAtiksuBertarafValue(e.value)
                                }}
                            />
                        </div>
                        <div className="field">
                            <label >Açıklama</label>
                            <InputText maxLength={100}
                                id='aciklama'
                                onChange={(e: any) => {
                                    setAddAritmaData({ ...addAritmaData, aciklama: e.target.value })
                                }}
                            />
                        </div>
                        <div className="field">
                            <label >Arıtma Çamur Miktarı (ton/gün)</label>
                            <InputNumber
                                min={0}
                                minFractionDigits={0}
                                maxFractionDigits={2}
                                id='aritma_camur_miktari'
                                name="aritma_camur_miktari"
                                onChange={(e) =>
                                    setAddAritmaData({ ...addAritmaData, aritma_camur_miktari: e.value })
                                }
                                onKeyDown={(e: any) => {
                                    const selection = e.target.value.substring(
                                        e.target.selectionStart,
                                        e.target.selectionEnd,
                                    );
                                    const deger = addAritmaData?.aritma_camur_miktari;
                                    if (selection === "" && deger && deger.toString().length === 7) {
                                        if (!isNaN(+e.key)) {
                                            e.preventDefault()
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div className="field">
                            <label>AAT Çevre İzni Var Mı</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, cevre_izni: e.target.value })
                                        }
                                        checked={addAritmaData?.cevre_izni === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, cevre_izni: e.target.value, cevre_izin_tarihi: "", cevre_izin_gecerlilik_tarihi: "" })
                                        }
                                        checked={addAritmaData?.cevre_izni === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.cevre_izni === true)
                            &&
                            <div style={{ display: "flex" }}>
                                <div className="field">
                                    <label >Çevre İzin Tarihi</label>
                                    <Calendar dateFormat="dd.mm.yy"
                                        value={new Date(addAritmaData?.cevre_izin_tarihi)}
                                        onChange={(e: any) => setAddAritmaData({ ...addAritmaData, cevre_izin_tarihi: e.target.value })}
                                    />
                                </div>
                                <div className="field">
                                    <label >Çevre İzin Geçerlilik Tarihi</label>
                                    <Calendar dateFormat="dd.mm.yy"
                                        value={new Date(addAritmaData?.cevre_izin_gecerlilik_tarihi)}
                                        onChange={(e: any) => setAddAritmaData({ ...addAritmaData, cevre_izin_gecerlilik_tarihi: e.target.value })}
                                    />
                                </div>
                            </div>
                        }
                        <div className='decharge' style={{ display: "flex" }}>
                            <div className="field">
                                <label >Deşarj Havzası</label>
                                <InputText maxLength={255}
                                    onChange={(e: any) => setAddAritmaData({ ...addAritmaData, desarj_havzasi: e.target.value })}
                                />
                            </div>
                            <div className="field">
                                <label >Deşarj Mesafesi (m)</label>
                                <InputNumber
                                    min={0}
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    id='desarj_mesafesi'
                                    name='desarj_mesafesi'
                                    onChange={(e) =>
                                        setAddAritmaData({ ...addAritmaData, desarj_mesafesi: e.value })
                                    }
                                    onKeyDown={(e: any) => {
                                        const selection = e.target.value.substring(
                                            e.target.selectionStart,
                                            e.target.selectionEnd,
                                        );
                                        const deger = addAritmaData?.desarj_mesafesi;
                                        if (selection === "" && deger && deger.toString().length === 7) {
                                            if (!isNaN(+e.key)) {
                                                e.preventDefault()
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="field">
                            <label>Atık yönetimi var mı</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) => setAddAritmaData({ ...addAritmaData, isAtikYonetimi: e.target.value })}
                                        checked={addAritmaData?.isAtikYonetimi === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) => {
                                            setAddAritmaData({
                                                ...addAritmaData,
                                                isAtikYonetimi: e.target.value,
                                                atik_yonetim_alt_faaliyet: ""
                                            })
                                        }
                                        }
                                        checked={addAritmaData?.isAtikYonetimi === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.isAtikYonetimi === true)
                            &&
                            (
                                <div className="field">
                                    <label>Atık Yönetimi Alt Faaliyetleri</label>
                                    <InputText maxLength={255}
                                        id='atik_yonetim_alt_faaliyet'
                                        onChange={(e: any) => setAddAritmaData({ ...addAritmaData, atik_yonetim_alt_faaliyet: e.target.value })}
                                    />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Kullanma Suyu Arıtma Tesisi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isKullanmaSuyuTesis: e.target.value })
                                        }
                                        checked={addAritmaData?.isKullanmaSuyuTesis === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isKullanmaSuyuTesis: e.target.value, kullanma_suyu_aritma_kapasite: "" })
                                        }
                                        checked={addAritmaData?.isKullanmaSuyuTesis === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.isKullanmaSuyuTesis === true) &&
                            (
                                <div className="field">
                                    <label>Kapasitesi (m³/gün)</label>
                                    <InputNumber
                                        id='kullanma_suyu_aritma_kapasite'
                                        name='kullanma_suyu_aritma_kapasite'
                                        min={0}
                                        minFractionDigits={0}
                                        maxFractionDigits={2}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, kullanma_suyu_aritma_kapasite: e.value })
                                        }
                                        onKeyDown={(e: any) => {
                                            const selection = e.target.value.substring(
                                                e.target.selectionStart,
                                                e.target.selectionEnd,
                                            );
                                            const deger = addAritmaData?.kullanma_suyu_aritma_kapasite;
                                            if (selection === "" && deger && deger.toString().length === 7) {
                                                if (!isNaN(+e.key)) {
                                                    e.preventDefault()
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Sıfır Atık Yönetim Sistemi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isSifirAtikYonetim: e.target.value })
                                        }
                                        checked={addAritmaData?.isSifirAtikYonetim === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isSifirAtikYonetim: e.target.value, sifir_atik_yonetim_sistemi: "" })
                                        }
                                        checked={addAritmaData?.isSifirAtikYonetim === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.isSifirAtikYonetim === true) &&
                            (
                                <div className="field">
                                    <label>Sıfır Atık Yönetim Sistemi</label>
                                    <InputText maxLength={100}
                                        id='sifir_atik_yonetim_sistemi'
                                        onChange={(e: any) =>
                                            setAddAritmaData({ ...addAritmaData, sifir_atik_yonetim_sistemi: e.target.value })
                                        }
                                    />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Çevre Yönetim Birimi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton
                                        value={true}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isCevreYonetimBirimi: e.target.value })
                                        }
                                        checked={addAritmaData?.isCevreYonetimBirimi === true}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton
                                        value={false}
                                        onChange={(e) =>
                                            setAddAritmaData({ ...addAritmaData, isCevreYonetimBirimi: e.target.value, cevre_yonetim_birimi: "" })
                                        }
                                        checked={addAritmaData?.isCevreYonetimBirimi === false}
                                    />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (addAritmaData?.isCevreYonetimBirimi === true) &&
                            (
                                <div className="field">
                                    <label>Çevre Yönetim Birimi Türü</label>
                                    <InputText maxLength={50}
                                        id='cevre_yonetim_birimi'
                                        onChange={(e: any) => setAddAritmaData({ ...addAritmaData, cevre_yonetim_birimi: e.target.value })}
                                    />
                                </div>
                            )
                        }
                    </div>
                    {
                        layer.perm >= 3 && zoneEdit &&
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Button style={{ minWidth: '80px', marginTop: "10px" }} label='Ekle'
                                onClick={() => { addPurification() }}
                                disabled={(addAritmaData === undefined || addAritmaData === null) ? true : false}
                            ></Button>
                        </div>
                    }
                </Dialog>
            }
            {
                selectedYetkili &&
                <Dialog header={'Yetkili Bilgileri'} className="feature-dialog" visible={true} modal={false} onHide={() => {
                    setEpostaHatali(false)
                    setSelectedYetkili(undefined);
                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                            <div className="field">
                                <label >Yetkili Adı *</label>
                                <InputText onInput={(e: any) => e.target.value = e.target.value.substring(0, 49)} maxLength={50} disabled={!(layer.perm >= 3 && zoneEdit)} value={selectedYetkili?.yetkili_adi} onChange={(e: any) => {
                                    if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/.test(e.target.value)) {
                                        setProceed(false)
                                        toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Yetkili Adı Alanına noktalama işaretleri ve rakam girilmemelidir.' });
                                    }
                                    else {
                                        setProceed(true)
                                    }
                                    setSelectedYetkili({ ...selectedYetkili, yetkili_adi: e.target.value })
                                }} />
                            </div>

                            <div className="field">
                                <label >E-Posta</label>

                                <InputText
                                    maxLength={50}
                                    disabled={!(layer.perm >= 3 && zoneEdit)}
                                    onChange={(e: any) => { updateYetkiliEmail(e.target.value, 'eposta') }}
                                    value={selectedYetkili?.eposta ? selectedYetkili?.eposta : ""}
                                />
                                {epostaHatali &&
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className='pi pi-info-circle' style={{ marginRight: '0.5em', fontSize: '1rem', color: '#D94B4B' }}></i>
                                        <p style={{ color: '#D94B4B', fontSize: '12px' }}>Hatalı E-posta Adresi. Örnek: example@email.com</p>
                                    </div>
                                }
                            </div>
                            <div className="field">
                                <label >Sanayi Sicil No</label>
                                <InputText onInput={(e: any) => e.target.value = e.target.value.substring(0, 49)} maxLength={50} disabled={!(layer.perm >= 3 && zoneEdit)} value={selectedYetkili?.sanayi_sicil_no} onChange={(e: any) => { setSelectedYetkili({ ...selectedYetkili, sanayi_sicil_no: e.target.value }) }} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                            <div className="field">
                                <label >Kurumu *</label>
                                <InputText onInput={(e: any) => e.target.value = e.target.value.substring(0, 49)} maxLength={50} disabled={!(layer.perm >= 3 && zoneEdit)} value={selectedYetkili?.kurumu} onChange={(e: any) => { setSelectedYetkili({ ...selectedYetkili, kurumu: e.target.value }) }} />
                            </div>
                            <div className="field">
                                <label >Heyet Tipi *</label>
                                <Dropdown disabled={!(layer.perm >= 3 && zoneEdit)} value={selectedYetkili?.heyet_tipi} options={heyetTipiDomain} onChange={(e: any) => { setSelectedYetkili({ ...selectedYetkili, heyet_tipi: e.value }) }}></Dropdown>
                            </div>
                            <div className="field">
                                <label >Heyet Ünvanı</label>
                                <Dropdown disabled={!(layer.perm >= 3 && zoneEdit)} value={selectedYetkili?.gorevi} options={heyetGorevDomain} onChange={(e: any) => { setSelectedYetkili({ ...selectedYetkili, gorevi: e.value }) }}></Dropdown>
                            </div>
                        </div>
                    </div>
                    {
                        !selectedYetkili.new && layer.perm >= 3 && zoneEdit &&
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-around' }}>
                            <Button style={{ minWidth: '80px' }} label='Sil' onClick={() => { onClickDeleteYetkili() }}></Button>
                            <Button style={{ minWidth: '80px' }} label='Güncelle' onClick={() => { onClickEditYetkili() }} disabled={(selectedYetkili?.yetkili_adi && selectedYetkili?.heyet_tipi && proceed) ? false : true}></Button>
                        </div>
                    }
                    {
                        selectedYetkili.new && layer.perm >= 3 && zoneEdit &&
                        <Button style={{ minWidth: '80px' }} label='Ekle' onClick={() => { onClickInsertYetkili() }} disabled={(selectedYetkili?.yetkili_adi && selectedYetkili?.kurumu && selectedYetkili?.heyet_tipi && proceed) ? false : true}></Button>
                    }
                </Dialog>
            }
            {
                selectedAritma && aritmalar && aritmalar.length > 0 &&
                <Dialog header={'Arıtma Bilgi Ayrıntıları'} className="feature-dialog" visible={true} modal={false} onHide={() => { setSelectedAritma(undefined); setPurificationStatus(false); }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className='main-info' style={{ display: "flex" }}>
                            <div className="field">
                                <label >Ada No</label>
                                <InputText maxLength={255} disabled={true} id='adaNo'
                                    value={selectedAritma.ada_no} />
                            </div>
                            <div className="field">
                                <label >Parsel No</label>
                                <InputText maxLength={255} disabled={true} id='parselNo'
                                    value={selectedAritma.parsel_no} />
                            </div>
                            <div className="field">
                                <label >Alan (m²)</label>
                                <InputText maxLength={255} disabled={true} id='alan'
                                    value={selectedAritma.alan} />
                            </div>
                        </div>
                        <div className="field">
                            <label >OSB Sınırları İçinde</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setOsbSinirState(e.value)} checked={purificationData?.sinir_durumu === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => setOsbSinirState(e.value)} checked={purificationData?.sinir_durumu === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        <div className="field">
                            <label >Plan Durumu</label>
                            <InputText maxLength={50} disabled={!purificationStatus} id='plan_durumu' onChange={(e) => handleChange(e)}
                                value={purificationData.plan_durumu} />
                        </div>
                        <div className="field">
                            <label>Merkezi Atıksu arıtma tesisi var mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setMerkeziAtiksuState(e.value)} checked={purificationData?.merkezi_atiksu_tesisi === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => {
                                        setMerkeziAtiksuState(e.value)
                                        setPurificationData({
                                            ...purificationData,
                                            "1_kademe_kapasite": null,
                                            "2_kademe_kapasite": null,
                                            "3_kademe_kapasite": null
                                        })
                                    }} checked={purificationData?.merkezi_atiksu_tesisi === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (merkeziAtiksuState || purificationData?.merkezi_atiksu_tesisi === true) && (
                                <div className='center-purification' style={{ display: "flex" }}>
                                    <div className="field">
                                        <label>1. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            disabled={!purificationStatus}
                                            id='1_kademe_kapasite'
                                            name="1_kademe_kapasite"
                                            onChange={(e: any) =>
                                                setPurificationData({
                                                    ...purificationData,
                                                    '1_kademe_kapasite': e.value.toString(),
                                                })

                                            }
                                            value={+purificationData["1_kademe_kapasite"] !== 0 && !isNaN(+purificationData["1_kademe_kapasite"]) ? +purificationData["1_kademe_kapasite"] : 0}
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = purificationData["1_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <label>2. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            disabled={!purificationStatus}
                                            id='2_kademe_kapasite'
                                            name="2_kademe_kapasite"
                                            onChange={(e: any) =>
                                                setPurificationData({
                                                    ...purificationData,
                                                    '2_kademe_kapasite': e.value.toString(),
                                                })
                                            }
                                            value={+purificationData["2_kademe_kapasite"] !== 0 && !isNaN(+purificationData["2_kademe_kapasite"]) ? +purificationData["2_kademe_kapasite"] : 0}
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = purificationData["2_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <label>3. Kademe Kapasitesi (m³/gün)</label>
                                        <InputNumber
                                            min={0}
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            disabled={!purificationStatus}
                                            id='3_kademe_kapasite'
                                            name="3_kademe_kapasite"
                                            onChange={(e: any) => setPurificationData({
                                                ...purificationData,
                                                '3_kademe_kapasite': e.value.toString(),
                                            })}
                                            value={+purificationData["3_kademe_kapasite"] !== 0 && !isNaN(+purificationData["3_kademe_kapasite"]) ? +purificationData["3_kademe_kapasite"] : 0}
                                            onKeyDown={(e: any) => {
                                                const selection = e.target.value.substring(
                                                    e.target.selectionStart,
                                                    e.target.selectionEnd,
                                                );
                                                const deger = purificationData["3_kademe_kapasite"];
                                                if (selection === "" && deger && deger.toString().length === 7) {
                                                    if (!isNaN(+e.key)) {
                                                        e.preventDefault()
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="field">
                            <label >Uygulanan Sürece İlişkin Bilgiler</label>
                            <Dropdown
                                id="uygulanan_surec"
                                filter
                                filterBy="name"
                                disabled={!purificationStatus}
                                value={uygulananSurecBilgi}
                                defaultValue={uygulananSurecBilgi?.name}
                                options={applicationPeriod}
                                optionLabel='name'
                                onChange={(e: any) => handleChange(e)}
                            />
                        </div>
                        <div className="field">
                            <label >Atıksu Bertaraf Yöntemi</label>
                            <Dropdown
                                id="atiksu_bertaraf"
                                filter
                                filterBy="name"
                                disabled={!purificationStatus}
                                value={atiksuBertarafYonetimi}
                                defaultValue={atiksuBertarafYonetimi?.name}
                                options={asidePeriod}
                                optionLabel='name'
                                onChange={(e: any) => handleChange(e)}
                            />
                        </div>
                        <div className="field">
                            <label >Açıklama</label>
                            <InputText maxLength={100} disabled={!purificationStatus} id='aciklama' onChange={(e) => handleChange(e)}
                                value={purificationData.aciklama} />
                        </div>
                        <div className="field">
                            <label >Arıtma Çamur Miktarı (ton/gün)</label>
                            <InputNumber min={0} minFractionDigits={2} maxFractionDigits={2} disabled={!purificationStatus} id='aritma_camur_miktari' onChange={(e) => handleChange(e)}
                                value={purificationData.aritma_camur_miktari} />
                        </div>
                        <div className="field">
                            <label>AAT Çevre İzni Var Mı</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setCevreIzniState(e.value)} checked={purificationData.cevre_izni === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => setCevreIzniState(e.value)} checked={purificationData.cevre_izni === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {(cevreIzniState === true || purificationData?.cevre_izni === true) &&
                            <div style={{ display: "flex" }}>
                                <div className="field">
                                    <label >Çevre İzin Tarihi</label>
                                    {!purificationStatus ?
                                        <InputText maxLength={255} disabled value={cevreIzinTarihi ? formatDate(cevreIzinTarihi) : "-"} /> :
                                        <Calendar dateFormat="dd.mm.yy"
                                            value={new Date(cevreIzinTarihi)}
                                            onChange={(e: any) => setCevreIzinTarihi(e.target.value)}
                                        />
                                    }
                                </div>
                                <div className="field">
                                    <label >Çevre İzin Geçerlilik Tarihi</label>
                                    {!purificationStatus ?
                                        <InputText maxLength={255} disabled value={cevreIzinGecerlilikTarihi ? formatDate(cevreIzinGecerlilikTarihi) : "-"} /> :
                                        <Calendar dateFormat="dd.mm.yy"
                                            value={new Date(cevreIzinGecerlilikTarihi)}
                                            disabled={!purificationStatus}
                                            onChange={(e: any) => setCevreIzinGecerlilikTarihi(e.value)}
                                        />
                                    }
                                </div>
                            </div>
                        }
                        <div className='decharge' style={{ display: "flex" }}>

                            <div className="field">
                                <label >Deşarj Havzası</label>
                                <InputText maxLength={255} disabled={!purificationStatus} id='desarj_havzasi' onChange={(e) => handleChange(e)}
                                    value={purificationData.desarj_havzasi} />
                            </div>

                            <div className="field">
                                <label >Deşarj Mesafesi (m)</label>
                                <InputNumber min={0} minFractionDigits={2} maxFractionDigits={2} disabled={!purificationStatus} id='desarj_mesafesi' name='desarj_mesafesi' onChange={(e: any) => setPurificationData({
                                    ...purificationData,
                                    desarj_mesafesi: e.value.toString(),
                                })}
                                    value={purificationData.desarj_mesafesi} />
                            </div>
                        </div>
                        <div className="field">
                            <label>Atık yönetimi var mı</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setAtikYonetimState(e.value)} checked={atikYonetimState === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => {
                                        setAtikYonetimState(e.value)
                                        setAtikYonetimDurum(true)
                                        setPurificationData({
                                            ...purificationData,
                                            atik_yonetim_alt_faaliyet: ""
                                        })
                                    }} checked={atikYonetimState === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (atikYonetimState || purificationData?.atik_yonetim_alt_faaliyet !== "") && (
                                <div className="field">
                                    <label>Atık Yönetimi Alt Faaliyetleri</label>
                                    <InputText maxLength={255} disabled={!purificationStatus} id='atik_yonetim_alt_faaliyet' onChange={(e) => handleChange(e)}
                                        value={purificationData.atik_yonetim_alt_faaliyet} />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Kullanma Suyu Arıtma Tesisi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setKullanmaSuyuAritmaState(e.value)} checked={kullanmaSuyuAritmaState ? (kullanmaSuyuAritmaState === true) : selectedAritma?.kullanma_suyu_aritma_kapasite !== null
                                        } />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => {
                                        setKullanmaSuyuAritmaState(e.value)
                                        setKullanmaSuyuAritmaDurum(true)
                                        setPurificationData({
                                            ...purificationData,
                                            kullanma_suyu_aritma_kapasite: ""
                                        })
                                    }} checked={kullanmaSuyuAritmaState ? (kullanmaSuyuAritmaState === false) : selectedAritma?.kullanma_suyu_aritma_kapasite === null} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (kullanmaSuyuAritmaState || purificationData?.kullanma_suyu_aritma_kapasite !== (null || "")) && (
                                <div className="field">
                                    <label>Kapasitesi (m³/gün)</label>
                                    <InputNumber
                                        min={0}
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        disabled={!purificationStatus}
                                        id='kullanma_suyu_aritma_kapasite'
                                        name='kullanma_suyu_aritma_kapasite'
                                        value={+purificationData.kullanma_suyu_aritma_kapasite !== 0 && !isNaN(+purificationData.kullanma_suyu_aritma_kapasite) ? +purificationData.kullanma_suyu_aritma_kapasite : 0}
                                        onKeyDown={(e: any) => {
                                            const selection = e.target.value.substring(
                                                e.target.selectionStart,
                                                e.target.selectionEnd,
                                            );
                                            const deger = purificationData?.kullanma_suyu_aritma_kapasite;
                                            if (selection === "" && deger && deger.toString().length === 7) {
                                                if (!isNaN(+e.key)) {
                                                    e.preventDefault()
                                                }
                                            }
                                        }}
                                        onChange={(e: any) => {
                                            setPurificationData({
                                                ...purificationData,
                                                kullanma_suyu_aritma_kapasite: e.value !== null ? e.value.toString() : ""
                                            })
                                        }}
                                    />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Sıfır Atık Yönetim Sistemi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setSifirAtikState(e.value)}
                                        checked={sifirAtikState === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => {
                                        setSifirAtikState(e.value)
                                        setSifirAtikDurum(true)
                                        setPurificationData({
                                            ...purificationData,
                                            sifir_atik_yonetim_sistemi: ""
                                        })
                                    }} checked={sifirAtikState === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (sifirAtikState || purificationData?.sifir_atik_yonetim_sistemi !== "") && (
                                <div className="field">
                                    <label>Sıfır Atık Yönetim Sistemi</label>
                                    <InputText maxLength={100} disabled={!purificationStatus} id='sifir_atik_yonetim_sistemi' onChange={(e) => handleChange(e)}
                                        value={purificationData.sifir_atik_yonetim_sistemi} />
                                </div>
                            )
                        }
                        <div className="field">
                            <label>Çevre Yönetim Birimi Var Mı?</label>
                            <div className='field-boolean-container' style={{ display: "flex", marginTop: "7px" }}>
                                <div>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={true} onChange={(e) =>
                                        setCevreYonetimBirimiState(e.value)}
                                        checked={cevreYonetimBirimiState === true} />
                                    <label style={{ marginLeft: "10px" }}>Evet</label>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <RadioButton disabled={!(layer.perm >= 3 && zoneEdit) || !purificationStatus} value={false} onChange={(e) => {
                                        setCevreYonetimBirimiState(e.value)
                                        setCevreYonetimDurum(false)
                                        setPurificationData({
                                            ...purificationData,
                                            cevre_yonetim_birimi: ""
                                        })
                                    }} checked={cevreYonetimBirimiState === false} />
                                    <label style={{ marginLeft: "10px" }}>Hayır</label>
                                </div>
                            </div>
                        </div>
                        {
                            (cevreYonetimBirimiState || purificationData?.cevre_yonetim_birimi !== "") && (
                                <div className="field">
                                    <label>Çevre Yönetim Birimi Türü</label>
                                    <InputText maxLength={50} disabled={!purificationStatus} id='cevre_yonetim_birimi' onChange={(e) => handleChange(e)}
                                        value={purificationData.cevre_yonetim_birimi} />
                                </div>
                            )
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-around', marginTop: "10px" }}>
                        {!purificationStatus && layer.perm >= 3 && zoneEdit &&
                            <Button onClick={() => deletePurification(selectedAritma?.id)}
                            >Arıtma Tesisini Sil</Button>
                        }
                        {!purificationStatus && layer.perm >= 3 && zoneEdit &&
                            <Button onClick={() => {
                                setEditPurificationToast(true)
                            }}>Güncelle</Button>
                        }
                        {purificationStatus &&
                            <>
                                <Button onClick={() => { cancelProcess() }}>İptal</Button>
                                <Button disabled={(!atikYonetimDurum || !cevreYonetimDurum || !kullanmaSuyuAritmaDurum || !sifirAtikDurum) ? true : false} onClick={() => { updateOSBPurification() }}>Kaydet</Button>
                            </>
                        }
                    </div>
                </Dialog>
            }
            <Toast ref={toast} />
            {
                editToast &&
                <div className='cont'>
                    <div className='warningg'>
                        <div style={{ position: 'absolute', top: '1.5em', right: '2em', cursor: 'pointer' }} >
                            <i className="pi pi-times" style={{ color: 'white' }} onClick={() => setEditToast(false)}></i>
                        </div>
                        <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                <div>
                                    <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                                </div>
                                <div>
                                    <p style={{ fontSize: '17px' }}> Osb bilgilerini güncellemektesiniz. Lütfen bilgilerin doğruluğundan emin olduğunuz taktirde güncellemeyi gerçekleştirin.
                                    </p>
                                </div>
                            </div>
                            <div className='group' >
                                <Checkbox inputId='info' onChange={(e) => setCheckboxStatus(!checkboxStatus)} checked={checkboxStatus}></Checkbox>
                                <label htmlFor='info' style={{ marginLeft: '8px', cursor: 'pointer' }} className='p-checkbox-label'>Okudum, anladım. Onaylıyorum.</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1em' }}>
                                <Button disabled={!checkboxStatus} type="button" label="Tamam" className="ok-button" onClick={hideToast} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                editInfrastructureToast &&
                <div className='cont'>
                    <div className='warningg'>
                        <div style={{ position: 'absolute', top: '1.5em', right: '2em', cursor: 'pointer' }} >
                            <i className="pi pi-times" style={{ color: 'white' }} onClick={() => setEditInfrastructureToast(false)}></i>
                        </div>
                        <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                <div>
                                    <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                                </div>
                                <div>
                                    <p style={{ fontSize: '17px' }}> Osb bilgilerini güncellemektesiniz. Lütfen bilgilerin doğruluğundan emin olduğunuz taktirde güncellemeyi gerçekleştirin.
                                    </p>
                                </div>
                            </div>
                            <div className='group' >
                                <Checkbox inputId='info' onChange={(e) => setInfrastructureStatus(!infrastructureStatus)} checked={infrastructureStatus}></Checkbox>
                                <label htmlFor='info' style={{ marginLeft: '8px', cursor: 'pointer' }} className='p-checkbox-label'>Okudum, anladım. Onaylıyorum.</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1em' }}>
                                <Button disabled={!infrastructureStatus} type="button" label="Tamam" className="ok-button" onClick={hideToast2} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                editTuketimToast &&
                <div className='cont'>
                    <div className='warningg'>
                        <div style={{ position: 'absolute', top: '1.5em', right: '2em', cursor: 'pointer' }} >
                            <i className="pi pi-times" style={{ color: 'white' }} onClick={() => { setEditTuketimToast(false); setTuketimToastCheckboxStatus(false) }}></i>
                        </div>
                        <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                <div>
                                    <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                                </div>
                                <div>
                                    <p style={{ fontSize: '17px' }}> Osb bilgilerini güncellemektesiniz. Lütfen bilgilerin doğruluğundan emin olduğunuz taktirde güncellemeyi gerçekleştirin.
                                    </p>
                                </div>
                            </div>
                            <div className='group' >
                                <Checkbox inputId='info' onChange={(e) => setTuketimToastCheckboxStatus(!tuketimToastCheckboxStatus)} checked={tuketimToastCheckboxStatus}></Checkbox>
                                <label htmlFor='info' style={{ marginLeft: '8px', cursor: 'pointer' }} className='p-checkbox-label'>Okudum, anladım. Onaylıyorum.</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1em' }}>
                                <Button disabled={!tuketimToastCheckboxStatus} type="button" label="Tamam" className="ok-button" onClick={hideTuketimToast} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {editPurificationToast &&
                <div className='cont'>
                    <div className='warningg'>
                        <div style={{ position: 'absolute', top: '1.5em', right: '2em', cursor: 'pointer' }} >
                            <i className="pi pi-times" style={{ color: 'white' }} onClick={() => setEditPurificationToast(false)}></i>
                        </div>
                        <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                <div>
                                    <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                                </div>
                                <div>
                                    <p style={{ fontSize: '17px' }}> Osb Arıtma bilgilerini güncellemektesiniz. Lütfen bilgilerin doğruluğundan emin olduğunuz taktirde güncellemeyi gerçekleştirin.
                                    </p>
                                </div>
                            </div>
                            <div className='group' >
                                <Checkbox inputId='info' onChange={(e) => setTermStatus(!termStatus)} checked={termStatus}></Checkbox>
                                <label htmlFor='info' style={{ marginLeft: '8px', cursor: 'pointer' }} className='p-checkbox-label'>Okudum, anladım. Onaylıyorum.</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1em' }}>
                                <Button disabled={!termStatus} type="button" label="Tamam" className="ok-button" onClick={hideToast3} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            <ConfirmDialog />
        </>
    )
}
